var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1222 1287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e87;\n      }\n\n      .st1 {\n        fill: #a90000;\n      }\n\n      .st2 {\n        fill: #a00;\n      }\n\n      .st3 {\n        fill: #d6c3c0;\n      }\n\n      .st4 {\n        fill: #920403;\n      }\n\n      .st5 {\n        fill: #946a6a;\n      }\n\n      .st6 {\n        fill: #c2351f;\n      }\n\n      .st7 {\n        fill: #670906;\n      }\n\n      .st8 {\n        fill: #fff;\n      }\n\n      .st9 {\n        fill: #a95454;\n      }\n\n      .st10 {\n        fill: #fefefe;\n      }\n\n      .st11 {\n        fill: #b83115;\n      }\n\n      .st12 {\n        fill: red;\n      }\n\n      .st13 {\n        fill: #540000;\n      }\n\n      .st14 {\n        fill: #450204;\n      }\n\n      .st15 {\n        fill: #00007f;\n      }\n\n      .st16 {\n        fill: #a05;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,1210h1v5H0v-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M0,0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M0,0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M0,0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M0,0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M0,0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M0,0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M0,0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M0,0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M0,0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M0,0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M0,0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M0,0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M508.9,353.4c-1.5-4.7-6.8-8.3-10.9-10.7-26.6-15.8-79.7-21.3-83.7-61.3-6.4-63.8,68.2-82.8,112.1-102.3,68.2-30.2,82.8-83.8,38.2-144.7l-14.2-13.1c60.3,28.2,87.2,110.7,31,158.2-23,19.4-65.4,30.2-76.8,59.9-15.2,39.7,29.9,67.6,52.1,93s17.1,21.7,17.3,23.1-.9.3-.3,1.7,2.5,3.5,3,3.5h16.3c.1-2.6-2.6-4.8-5.3-5.3-2.1-7.7-7.8-14.2-10.2-21.8-26.7-84.1,86.1-101.3,82.7-177.4-.9-19.4-8.2-37.8-18.7-53.8-2.1-3.2-8.6-10-9.7-12.4s.3-2.1,1.6-1.6,7.3,6.2,9,7.9c38.1,37.9,57.7,88.4,21,135.6-20.1,25.9-56.6,35.7-69.5,68.2-8.6,21.6-4,38.4,8.6,56.4,1.6,2.4,2.7,3.4,4.2,5.3s1.6,2.4,3.2,4.2,1.8,3.9,2.9,4.2c34.9,2,69,9.2,103.3,14.7.3,0,.7,0,1.1,0,1,.1,2.1-.1,3.2,0,.1.5.6,1,1.1,1.1,1.3.1,2.9-.2,4.2,0v1.1c-.2.3.5,2-.6,2.2l-35.1-5.3c-.5,2.8.6,1.8,2.1,2.6,5.1,2.5,11,3.5,16.1,6,4,2,6.8,5,10.3,6.5,7.9,3.2,21.3,5,30.3,7.6,3.5,1,18.9,7,20.4,6.9s1.1-2.2,2.3-3.1c5.8-4,12.2-1.2,0-7.7-1.5-.8-3.3-.4-2.8-3,17,5.8,45.6,16.2,58.9,28.4,8.1,7.4,11.4,18.7,3.2,27.3,1-4.9,3.1-12.4-2.1-15.8,4.2,15.5-4.3,22.9-15.8,30.5l10.1-19.9c.8-1.2,3.2-1.6,3.5-2.8.5-2.1-7.2-17.1-11-18.3-1.6,1-1.4,2.1-1.6,3.6-1.8,13.7-10.3,26.1-15.8,38.9-1.7,4-.5,5.7-5.2,9-2,1-3.7,1.4-5.3,2.1-.7-1.7-2.3-2.2-3.8-3-50.1-25.5-108.4-33.1-163.8-39.1l-2.7,3.2c41.2,4.8,82.6,10,122.3,22.3,1.4.4,2.4,1.8,2.8,1.9.9,3.8-4.3,1.6-7.4,2.1-.9-1.6-4.3-1.4-5.7-.9-2,.7-.8,4-3.8,3,.8-8.4-6.2-6-10.8-7.4s-1.9-3.5-4.5-4.2-2.2.3-1.5,1.5,4,.7,3.1,3.7c-4,0-5-3.1-9.5-3.1s-2.6-.9-3.8-1.1c-2.6-.4-5.8,1.4-4.6,4.3,3.1-2.1,1.7.7,2.1,1-2.3.7.1,3.1,1,3.8,5.1,4,9.1.2,13.7-1.6,0,1,0,2.1,0,3.2-6.9,3.2-16.2,4-17.9-5.3-3.8,3-9.3,4.4-13.6,1.5s-2-3.6-2.8-3.7c-2.7-.4-6,4.1-11.8,1.5s-.9-3-1.3-3.5-4.3.1-2.1-2.1,1.9,2,2.1,2.1c1.5,1.1,11.2,1.1,13.2-1l-5.3-4.2c-3.2-.5-1.6,1.8-4.7,2.1,2.4-3.8-2-4-2.1-4.2s1.1-1.3.6-2.1c-2.5,1.3-5.8-.6-9-1.1.3.1,3.9,4.5,3.1,5.3-2.1.4-2.8-2-4.8-2.1-3.1-.3-7.1,4.4-11-.5,2.8-.8,10.1-3.6,12.6-2.6-35.5-5.7-73.4-6.7-109.9-8.5-7.4,3.4-16.2,8.4-21.5,14.8-.7,0-1.4,0-2.1,0-4.7,0-21.1-.9-23.7,1-1.9,1.4-6,9.6-6.7,12.2-1.7,6.4-1.1,10.8-.5,17.2s1.1,3.3-1.1,2.2c-6.4-3.3-7.8-26.1-2.5-31.9l12.4-14.4c-7.2,2-18.9-1.9-22.6,5.2l-.5-3.1c-2.7-.6-5.4,1-7.9,1-5.6,0-10.8-.3-16.3,0s-6,1.7-8.4,2.1-.9-1.1-2.3-.9c-6.3,1.1-10.6,2.9-16,3s-7.8-.6-10.3,1,.3,4.4-7,1.1c.8,5.1-1.6,2.4-4.6,3.1s-2.5,6.6-2.8-2.1c-5.2,3.6-8-.6-13.7,0,0,1.8,3.3,1.1,5,1.8,4.9,2-3.6,3.8-6,3.4-.4-.4.6-3.3-.5-3.1-4.3.7-3.9,1.5-3.2,5.2-.9-.8-2.6-1.2-3.7-1-2.7-4.9-6.5-1.1-9.5,0s-4.6,1.4-7.4,3.2c-3.4-5.4-4.3,0-5.5.8s-2.8,0-4,.2c2.7-1.1,1.7-2.5,2.1-4.2s1.1-1.3,1.1-2.1c40.5-6.9,80.9-14.8,122.4-15.8,2.1-.4,3.9-2.3,4.8-4.2-9.9.4-20.1.4-29.9,1.1-33.1,2.3-66,6.7-98.3,13.7-3.5.7-7,1.3-10.5,2.1l-17.9-58.9c-13.8,3.8-28.3,5.5-41.1,12.2l21.1,57.2c-7.9,2.8-17.7,6.3-24.2,11.6-3.9,1.2-7.5,1.7-10.5,5.3-12.1-5.3-25.4-10.1-34.7-20s-7.7-10.8-7.4-17.9,1-.8,1.1-3.2,0-1.4,0-2.1c4.8-6.2,10.1-11.3,15.8-16.8-2.1-.5-2.9.7-4.2,1.5-6.8,4.1-13.5,11-18.4,17.4-2.1-6.3,1.9-12.2,3.7-17.9,12-15,29.9-22.4,46.2-31.5,32.6-11.2,67.4-19.1,101.6-24,46.4-6.7,94.4-9.4,141.2-9.6-2.5-3-3.7-7.4-8.4-6.3ZM528.6,336.9c-1.6-2.6-14.4-12.4-17.6-15.5-20.6-20.1-41.1-38.8-34-70.8,9-40.6,56.8-51.8,86.5-74.4,2.1-1.6,12.6-10.6,13.2-12,1.1-2.3,0-5.8-2.2-6.2s-15.9,13.3-19,15.5c-4.1,3-15.9,8.8-18.1,11.3s-1.1,3.7-3.3,5.2c-14.1,10.1-39.9,14.8-54.5,25.4-15.5,11.2-33,31.7-34.8,51.4-3.2,36.4,28.5,51.4,54.1,67.8,2.8,1.8,8.7,7.3,11,8s6.3-1.1,9.9-.6c3.9.5,6.9,4.5,11.1,4.2.3-.3-2.1-8.7-2.4-9.2ZM355.4,376.6c-6.2,1-11.9,2-17.9,3.2-26.9,5.2-69.4,16.5-91.4,33.2s-10.2,9.5-10.6,10.4c-1.8,4.2,4.9-1.4,5.6-1.8,25.2-14,73.4-25.4,102.5-32.1,19.4-4.4,39.3-7.6,58.8-11.6s3.7-.3,5.5-.3c.2-1.8-2.4-1-3.7-1-5.7-.2-12.2-.2-17.9,0s-9.6,2.5-14.1,0c33.6-4.6,67.5-7.8,101.4-9.5s31.3-.2,46.8-1l-1.2-4c-54.9.2-109.7,5.4-163.8,14.6ZM600.3,369.2c-1.8-7.1-17-4.1-23.1-5.2-.8,7.3,9.4,3.1,14,4.2s.7,2,1.4,2.1c1.9.2,5.3-1.9,7.7-1.1ZM248.8,422.8v1.1c.7-.4.7-.7,0-1.1ZM234,424.9v1.1c.7-.4.7-.7,0-1.1ZM608.8,439.6c-5.9,1.1-56-3.2-56.8-.5s2.3,1.5,3.7,1.6c15.1.6,30.1,1.6,45.2,2.2,3,.1,8.1.9,7.9-3.2ZM692.8,464.8c1.3-1.8-5-6.4-7.2-5.1s-1.7,4.8-7.5,3c1.5,4.4,5,6.2,9.5,4.8s5-2.5,5.2-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M508.9,353.4c4.7-1.1,5.9,3.3,8.4,6.3-46.9.2-94.8,2.9-141.2,9.6-34.2,4.9-69,12.8-101.6,24-7.6,2.6-11.5,3.5-18.9,7.4-4.1,1.1-7.8,3.3-11.6,5.3s-3.4,2.2-5.3,3.2c-16.2,8.9-25,13.7-34.7,30.5s-4.4,4.8-4.2,11c.2,8.4,2.9,15.5,8.4,21.6,1.3,2.5,3.7,6.2,5.6,8.1s1.6.2,1.8.3c1.7,1.7,3.8,4.5,5.3,5.7,2.3,1.8,7.4,3.5,8.4,5.8s-1.7,3.9,3.2,3.2c.3.9-1,1.7-1.1,2.1-1.9.4-3.8-1.8-2.3,1.7,3.6,8,8.1,15.6,11.7,23.5s4.8,9.1,6.3,12.6.3,2.6,1.1,4.2c11.3,25.8,22,51.9,30.5,78.8s7.8,28.1,12.1,42.1c2.6,0-8.3-36.4-9.2-39.3s-1.8-2.5-1.9-2.8c-1.5-5.2-4.4-15.6-5.2-20.6s-.6-2.4.4-2.5c8,14.7,15.1,30.2,19.8,46.4,9.9,34.1,16.8,68.9,18.6,104.9s-1,8.7,1.1,11.6c.1,1.7,0,3.5,0,5.3l-5.2,66.2c4.5-6.2,8.5-13.3,11.7-20.3,34.1-73.1,19.7-145.3-14-215.4s-2.5-7.5-6.2-11.9-5.5-1.2-1.1-3.7c.6,0,1.9-1.5,3.5-1,2.5.8,3.8,8.1,12.2,8.9,6,.6,5.9-4.6,8.9-3.8,1,1.1,1.8,2.7,2.3,4,30.3,80.8,40,183.8,24.2,268.5s-38.2,114.9-42.8,168c-5.5-.7-10.4-8.6-12.5-13.3-9.5-21.1,11.5-44.5,20-62.7,5-10.7,9.3-23,12.4-34.4,3.5-12.7,8.6-32.4,9.5-45.2,4.4.6,1.1-2.9,1.1-4.2s0-2.8,0-4.2c4.4.6,1.1-2.9,1.1-4.2s0-2.1,0-3.2c3.2,1.1,2.2-4.4,2.1-7.4s0-2.8,0-4.2c1-5.8,1.9-13.5,2.1-19.4s-.2-10.9,0-16.3c-.2-.3-1.3.5-1.6,1-4.8,7.3-7.3,29.2-12.3,38.1-9.2,21.7-19.2,44.1-31.1,64.5-1.4,2.4-7.7,12.8-9.1,14-2.1,1.8-3.6.5-5.8,0,6.5-30.6,13.3-62.4,16.8-93.6s1.3-13.3,1-20l-3.1,12.6c-5.5-1-2.4,5.5-7.4,4.2,14.9-104.4-12.3-203.6-56.6-297.1-10-21.2-18.4-32.1-31.5-50.4-39.6-55.4,54.7-87.1,93.1-97.8,68.7-19.1,141.4-24.4,212.6-26.6ZM296.6,685.6c3.1,18.1,5.6,42,6.4,60.4s-.5,38.4-.6,57.3c9.3-40.1,3.5-78.3-4.7-117.7-1.7-8.1-3.2-16.3-5.8-24.2-1.6,0,2.8,19.3,3.1,21.1s1.5,2.7,1.6,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M840,480.6c0,.3,0,.7,0,1.1-2.5,1.6-2,2-2.1,2.1-.8.6-8.4,4.2-10.5,5.3-5.9,3.1-13.9,7-20,9.5-18.5,7.6-39.5,13.1-58.9,17.9-.5-2.4,4.2-3.6,5.8-4.2,10.3-4,20.8-7.4,31-11.6s15.5-5.9,23.1-10,17.8-11,27-16.1c3-1.3,4.1,3.8,4.5,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M602.4,356.6c41.6,2.1,84.3,6.3,125.3,14s118.9,26.8,135.1,62.5c12,26.5-7.7,39.6-19.2,60.1-9.4,16.9-17.4,37.4-24.4,55.5-5.4,14.1-19,45.8-17,59.6s3.9,7.5,8.9,8c10.1,1,35.1-15.3,46.1-20.2,92-41,197.8-27,234.1,77.4s2.6,142.6-37.9,201.3c-1.5,0-2.7-.6-3.2-2.1,56.9-84.5,70.1-234.6-41.3-280.8-63.4-26.3-134-1.9-189.9,30.7-5.6-.7-5.9,1.1-9.5,2.1s-.8-1.1-2.1-.6c-3.2,1.1-7.2,7.1-8.4,10.1h-1.1c-.8-1.1-2.2-.7-3.2-1.1s-.7-1.5-2.1-1c-.2,2.5-1.4,5.5,1,7.4h1.1c0,.9,1.3,2.6,2.1,3.2-3.6,15-6.3,28.7-8.4,44.1-2.3-.2-3.7,0-4.2,2.6-.4,2.1-.5,12.6,1.1,13.1s2.4-.5,3,.1,2.3,11,6.4,12.5,1.4,0,2.1,0c1.6,2.3,4.1,2.4,6.6,1.9,10.8-2.1,25.7-29.5,33.9-38.7,20.6-23.2,47.9-38.8,78.3-45.2,1.6-.3,2-1,2.1-1.1,1-.2,2.2.1,3.2,0,1.9-.3,3-1,3.2-1.1,2.1-.2,4.2,0,6.3,0,5.2-.2,10.5.1,15.8,0,13.2,1.7,20.6,4,32.6,9.5-2.7-.6-2.6,2.1-3.2,4.2-45.9-19.5-99.3,1.5-131.4,36.2s-22.1,34.5-35.4,41.4c-9.9,5.1-17.8,5.2-25.6,15.4-18.1,23.7-2.2,89.2,4.7,117.2,4.4,17.5,9.6,36.1,14.9,53.4,4,12.8,10.8,38.5,18.2,48.6-5-.7-3.3,2.3-4.2,4.2s-.8,1.1-1.1,2.1c-.9,3.7-.7,8.2-1.9,11.2s-3.7,4.3-4.4,10.9c.3-12.9,0-25.4-2.4-38.1-8.3-42.1-26.4-83.3-34.4-127-4.4-23.9-5.7-44.5-6.3-68.3,1.7.3,2.4-.8,3.2-2.1,5.9-9.7,4.9-17.2,16.5-25.1s10.4-4,10.9-4.4c3.1-2.8-5.2-2.1-7.1-1.3s-7.9,5.4-8.3,5.9c-2.3,2.4-1.9,8.2-5.7,5.5s-.7-6.6-1-9c1.9-18.6,3.5-37.2,6.3-55.7.2-.5,1.9-1.6,1.8-2.9l11.8-45.5c3.1.5,1.7,8,3.7,8.4l7.9-2.1-8.9-7.4-3.7-10.5c-3.7,13.5-9.1,26.4-12.6,39.9h-1.1c8-32.9,17.5-60.7,29.4-92.5,7.8-20.6,16.8-40.6,26.3-60.5-2.2.2-4.5,2.7-6.3,3.7-3.7,2-7.8,4.5-11.6,6.3s-5.3,1.2-7.4,2.1c2.2-1,2.4-3.2,3.2-5.3,5.5-2.7,10.6-6.1,15.8-9.5s5-3.2,8.4-6.3,1.9,1.4,2.1-2.1c.6-.4,1.5-.6,2.1-1.1,6.7-5,16.8-20.6,17.8-29,1.2-10.1-3-15.3-8.3-22.5-9.4-12.6-16.9-16.2-30.5-23.1-26.5-13.5-72.4-28.5-102-30.5-1.5-1.5-3.4-1-5.3-1.1s-.7,0-1.1,0c-34.8-7.4-70.7-9.8-106.2-12.6-1.5-1.9-2.6-2.9-4.2-5.3ZM787.4,710.8c-1.3-1.4-9.4,2.1-7.3,6.3,1.8-.7,9.6-3.9,7.3-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1050.2,872.7c.5,1.5,1.6,2.1,3.2,2.1-42.2,61.3-84.9,91.1-140.3,137.7-26.3,22.1-40.1,38.4-61.5,64.6-15.7,19.2-19.2,15.3-38.5,25.6-19,10.1-29.6,40.8-42,58.9-12.6,18.4-31.8,39-46.7,56.3-47.1,54.7-178.9,56.1-245.4,50-45.2-4.2-123.1-18.2-152.9-55.2-21.7-27-44.4-53.6-59.8-85.3-7.5-15.5-13.5-32.1-18-48.7,6.7.1,4.4-5.4-1.1-5.3-1.4-5.7-4.6-14.3-4.2-20s3.4-3.6-1.1-3.2c-.1-1.7.2-3.5,0-5.3,2.2-2.5,3.3-6.2-1.1-6.3-.2-7.1.8-13.2,1.1-20,2.7.6,2.9-2.4,3.2-4.7l-3.2-.5c0-1.7,0-3.5,0-5.3,4.4.6,1.2-2.9,1.1-4.2s0-2.1,0-3.2c4.6.7,3.9-1.5,1.1-4.2.5-2,1.8-3.9,2.1-5.3,4.2.6,5.8-3.5,9.5-4.2-3.7,18.8-5,31.2-5.3,50.5s.3,6.1,1.1,11.6c1.7,13.2,5.4,28.2,6.5,39.4s2,4.8,4,7.9l1.6,6.3c13.1,30.7,35.4,76.7,63.6,95.7-1.1,4.1,1.9,5.3,3.2,7.4,19,29.9,70.2,41.9,103,48.4,34.5,6.8,68.4,9.9,103,9.5,42.5-.5,82.1-3.5,123-15.8s48.7-17,63-38.4c-4.2,2.2-13.9,5.2-17.2,7.8-1.2,1-.4,1.8-.7,2.2-7.1-.4-13,4.1-19.4,6.3-30.2,10.4-70.6,17.2-102.5,20-41.3,3.5-86.1,2-127.2-3.2-.7,0-1.4,0-2.1,0s-1.4,0-2.1,0c-33.3-4.6-67.5-13.9-98.8-26.3l1.1-4.2c14.8,6.2,52,17.9,67.3,17.9,10.7,3.1,22.1,4.8,33.2,6.2,43.9,5.4,92.5,6,136.5,2.2,6.7-.6,13.9-1.6,20.5-3.1,7.1-.4,13.3-2.3,20-3.2s.4.3,2.1,0,.7,0,1.1,0c9.3-1.5,15.3-2.3,24.2-5.3,3.7.4,7.1-.6,10.5-1.6,2.4-.7,4.3-2.4,5.3-2.6,36.3-10.9,51.5-15.8,76.7-45.2.3-.4.7-.7,1.1-1.1,19.8-23.7,35.8-50.7,46.2-79.9.1-.4.7-1,1.1-2.1,6.1-17.9,10.7-37.8,10.5-56.8.4-.3.7-.7,1.1-1.1,2.1-2.6.5-5.5,1.3-8.7s4.6-5.7,2.9-10.2l2.1,4.2c1.7,8.9-2.9,20.5-1.1,28.4.4,2.2-.8,4.2-1.1,6.3-4.5-.6-1.2,3.6-1.1,5.3s0,1.4,0,2.1c-3-.6-1.9,1.5-2.4,3.3-2,7.9-2.8,16.2-5,24-.8,2.9-3.8,7-3.7,10.5,5.4-6.5,15.5-6.5,21.6-10.5s1,.2,1-.5c-.2-.7-.7-.4-1-.5s-.8.1-1.1,0c-4.1-5.3-.4-7.5,0-10.5-.2,1.6-.2,2.1,1.1,3.2s.8-.2,1.1,0c-.2,2.4.2,3.1,2.1,4.2s6,2.3,5.3-1.1c10.4-3.7,20-22,27.4-31,30.1-36.9,70.7-63.4,106.6-94.1,28.4-24.3,63.1-57.8,83.6-88.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M288.2,875.9c-.4,9.3-6,21.8-8.7,30.7-5.7,18.9-11.5,37.8-17.6,56.6-3.8.5-1.3-1.3-1.3-3,0-5.4,0-11.1.3-16s.8-3.5,1.1-5.3l7.2-4.9c.1-2,2-4.8,2-6.4s-2-2.2-1.5-4.5,3-9,3.6-10.2c2.4-4.8,10.3-8.8,1.3-14,1.3-4.3,3-8.4,4.2-12.6,6.2-1.6,1.5-10,9.5-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.8,944.2c-.4,4.8-.3,10.6-.3,16s-2.4,3.4,1.3,3c-.4,1.4-1,2-1.1,2.1-2.9-.2-3.9,7.4-4.5,9.7s-2.1,3.3,1.4,2.9c-.3,1,.4,1.2-1.1,2.1s-6,1,0,2.1c-.3,1.7-.7,3.5-1.1,5.3-3.7.7-5.3,4.8-9.5,4.2,3.4-15.8,6.2-28.7,12.1-44.2s-.3-3.8,2.6-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M291.3,828.6l4,7.7c-3.3,3.3-1.5,8.2-2.1,10.5s-2.2,2.2-2.7,3.6c-2,6.2-1.7,9.7-1.8,16s-2.1,3.7,1.6,3.2c-.1.4-.9,2-1.1,2.1-.4.2-1.9-.2-2.1,0-.7.7,1,2,1,2.1,0,.6,0,1.4,0,2.1-8,.5-3.3,8.9-9.5,10.5,4.8-17.2,10-40.2,12.6-57.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M274.5,899c9,5.2,1.1,9.1-1.3,14s-3.3,8.9-3.6,10.2c-.5,2.3,1.5,2.9,1.5,4.5s-1.9,4.4-2,6.4l-7.2,4.9c2.1-12.8,8.9-27.3,12.6-39.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M298.7,821.2c-.2,2.3.3,5.1,0,7.4-2,13.7-4.8,27.6-8.4,41-3.6.5-1.6-1.4-1.6-3.2.1-6.3-.1-9.8,1.8-16s2.4-2.3,2.7-3.6c.6-2.3-1.2-7.2,2.1-10.5l-4-7.7c.1-1-.1-2.2,0-3.2,5,1.3,1.8-5.2,7.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M587.7,355.5c2.6.4,5.4,2.7,5.3,5.3h-16.3c-.4,0-2.6-2.7-3-3.5-.6-1.4.3-1.6.3-1.7,4.3.5,9.6-.6,13.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M248.2,1078.7c-.5-2-.7-3.6-1.1-5.3,5.4-.1,7.8,5.4,1.1,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.9,1013.6l3.2.5c-.2,2.3-.4,5.4-3.2,4.7,0-1.1,0-3.4,0-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.9,1045.1c-.2-1.8-1-3.4-1.1-6.3,4.4.1,3.3,3.8,1.1,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M244,996.8c2.8,2.7,3.5,4.9-1.1,4.2,0-2.6.7-2.7,1.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M243,1004.1c.2,1.3,3.4,4.8-1.1,4.2,0-1.5-.3-3,1.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M241.9,1050.4c4.4-.4,1.1,2.9,1.1,3.2-1-.9-1-1.9-1.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M524.7,458.6c18.5-.2,37.3-.6,55.7,1.1l-28.4,11.5c7.5-.6,15.9-1.7,23.1-3.6,5.3-1.4,13.6-6.3,18.3-6.9,6.7-.9,21.9,1.4,29.5,2.2,43.1,4.3,87.8,13.4,126.7,32.6-7.5,4.5-28.3,8.5-38.9,10.5-.6-2.5,1.3-2.2,2.8-3,5-2.7,11.4-4.5,5.7-11.2-7.3-8.6-49.5-16-61.5-17.3-25.7-2.8-51.5-2.3-77.2-1.1l61.2,9.8c8.6,1.8,38.5,8.6,43.3,14.5s-4.4,9.8-8.9,12.5c-8,4.8-13.7,3.2-22.6,4.2-17.2,2-32,3.7-49.5,4.2s-19.8,1.4-30.5,2c-27.2,1.6-55.3.7-81.9,1.1s-51.8-2.2-77.3-5.3c-.5-2.5,1.2-2.3,2.8-2.9,17.6-6.6,46.1-8.2,65.1-8.6s10.8,2.9,19.3,6.7c12.3,5.4,29.2,7.8,42.6,6.9s13.2-1.6,11-3.2c-17.5,1.4-43.4-11-44.7-30.5-.8-11.7,6-17.5,12.1-26.3.7,0,1.4,0,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M453.2,448c5.5-.3,10.7,0,16.3,0s5.2-1.6,7.9-1l.5,3.1c3.7-7.1,15.4-3.3,22.6-5.2l-12.4,14.4c-5.3,5.8-3.9,28.6,2.5,31.9s1.2-1.4,1.1-2.2c-.6-6.4-1.2-10.9.5-17.2s4.8-10.8,6.7-12.2c2.7-1.9,19-.9,23.7-1-6.2,8.8-13,14.6-12.1,26.3,1.4,19.5,27.2,31.8,44.7,30.5,2.2,1.6-9.7,3.1-11,3.2-13.4.9-30.3-1.5-42.6-6.9-8.6-3.8-8.5-6.9-19.3-6.7-19,.3-47.5,2-65.1,8.6-1.7.6-3.4.4-2.8,2.9-9.3-1.1-22.5-1.6-31.1-4.1s-.5-6.8,3.7-8c7.2-2.1,15.8-4.4,23.2-5.7,22.1-4.1,45.9-3.8,68.3-2.1-2.1-5.9-6.2-10.6-7.7-17s-.6-5.1-.7-8.2,0-4.9,0-7.4,0-2.1,0-3.2c-1.8-1.6-43,3.4-48.8,4.3-13.7,2.1-30.4,5.1-43.7,8.8-15.8,4.4-34.3,14.6-50.4,13.1l.5-6.3c-1.9,4.5-4.3,4.6-8.9,4.2,1.1,3.2,5,1.8,7.4,2.1-2.3,7.6-10-.4-10.5,0s-.3,2.1-1.5,3.2c-2.2,2-4.7,1.6-6.9,2.6-3.5,1.5,4.4,2.3-1,2.6-.9-.3-3.3.2-5.3-.5-2.8-1.1-8.3-5.6-9-5.7-2.1-.3-1.3,2.1-2,2s-.4-1-.6-1c.6-1.2-1.6-4-.5-4.2,6.6-1.3,9.7,5.6,12.1-5.2,1.8-.5.5,2.1,1.6,2.2s3.8-1.7,5.7-1.1c1.1-4.3-4.8-.3-5.3-3.1,2.4-1.3,10.1,1.4,10.5,1.1s.3-2.7,1-3.6,2.1-.5,2.2-.6c-.3.7.2,2.2,0,3.1,6.8,0,9.2-6.5,1-4.2,3.8-2.1,5.8-1.5,7.2-2.3s.4-3.5,4.4-4c.5,2.2-2.9,3.9-3.1,4.8-.9,3.8,7.7,2.2,8.4,1.5,2.2-2.2-2.7-1.7-2.1-3.1h8.4c.3-.9-1-1.7-1-2.1s0-.8.5-1h1.6c9.1,3.1,4.2-6,13.7-6.3-.4,1.7.6,3.1-2.1,4.2-8.6,1.3-2.5,5.7,3.5,4.2s1.3-2.4,2.3-3.2,2.5-1.3,3.7-2.1c2.8-1.7,4.4-2.1,7.4-3.2-1.2,6.7,5.4.5,9.5,0s2.8.2,3.7,1c-.7-3.7-1.2-4.5,3.2-5.2s.1,2.7.5,3.1c2.4.4,10.9-1.4,6-3.4-1.7-.7-4.9,0-5-1.8,5.7-.6,8.4,3.6,13.7,0,.3,8.7,2.3,2.2,2.8,2.1,3-.7,5.3,1.9,4.6-3.1,7.3,3.3,4.2.6,7-1.1s7.3-1,10.3-1c5.5,0,9.8-1.9,16-3s2.2.9,2.3.9c-.6,5.1,5.9-1,9.5,0l-1.1-2.1ZM332.3,482.7c2,1.8,12.2.7,11.6-4.2-3.6,2.3-6.1,2.5-10.1,2.2s-2.5,1-1.5,2ZM492.6,492.2v1.1c.7-.4.7-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.5,475.4c.4-.3.6-.8,1.1-1.1,0,0-1,.9-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M528.6,336.9c.3.5,2.7,8.8,2.4,9.2-4.2.4-7.2-3.7-11.1-4.2-3.7-.5-6.8,1.6-9.9.6s-8.2-6.2-11-8c-25.7-16.4-57.3-31.4-54.1-67.8s19.3-40.2,34.8-51.4c14.6-10.6,40.4-15.3,54.5-25.4,2.1-1.5,1.8-3.6,3.3-5.2,2.3-2.5,14-8.3,18.1-11.3,3.1-2.2,17.8-15.7,19-15.5,2.3.4,3.3,4,2.2,6.2s-11.2,10.4-13.2,12c-29.7,22.5-77.5,33.8-86.5,74.4-7.1,32,13.4,50.7,34,70.8,3.2,3.1,16,12.9,17.6,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M847.4,429.1c9.3,19.8-12.3,36.6-27.3,45.2s-1.4.7-2.1,1.1c-1.7.9-5,0-4.2,3.2-1.3.2-2.2.9-3.2,1.1-5.8,1.2-10.4,4.4-15.8,6.3-72.4,26-156.5,36-233.3,38.9-73,2.8-154.6-1.9-226-17.9-.4,0-1.7-.7-3.2-1.1s-.7,0-1.1,0c-1.3-.3-2-.8-4.2-1.1s-1.4,0-2.1,0c-.3-1-1.2-1-2.1-1.1-19.8-1.9-37.8-10.7-56.8-15.8-22.2-10.3-71-30.1-46.2-62h1.1c-3.2,5-4.2,13.5-2.9,19.2s9.5,16.1,13.4,15.5c1.5,3.8,1.8,4.9,6.3,3.2,9.3,9.8,22.6,14.7,34.7,20,1.7.7,3.5,2,6.3,3.2,4.7,1.9,4.8,2.6,10.5,3.2s.3,1,.6,1c.7,0-.2-2.4,2-2s6.2,4.7,9,5.7,4.3.1,5.3.5c4.5,1.7,9.8,6.7,15,5.1s2.2-2.5,4.4-2.9c25.6-4.9,55.2-2.7,81-1.1,2,.1,4.2-1.1,3.6,2.1-7.4,1.4-16,3.7-23.2,5.7-4.2,1.2-10.9,5.8-3.7,8s21.8,3,31.1,4.1c25.5,3.1,51.5,5.7,77.3,5.3s54.7.5,81.9-1.1c10.6-.6,19.6-1.7,30.5-2,17.4-.5,32.3-2.2,49.5-4.2,8.9-1,14.5.6,22.6-4.2,11.6.2,23.3-2.1,34.7-4.2,10.6-2,31.4-6,38.9-10.5s3.9.2,5.5-.3c6-1.6,14.3-2.8,18.7-7.1.2.2,1.5-.1,2.1,0l.5.7c.3-.1.3-.6.5-.7.4-.3.8-.9,1.1-1.1,1.6-.7,3.4-1.3,5.3-2.1s3-1.5,4.2-2.1,3.2-1.1,5.3-2.1c7.6-3.6,12.8-5.8,20-10.5,11.5-7.6,20-15,15.8-30.5,5.1,3.3,3.1,10.8,2.1,15.8s-3.1,4.4.5,4.2c3.7-4.1,8.8-7.4,11.1-12.6s2.1-6.7,2.1-9.5c0-8.1-4.9-13.4-8.4-20,4.3,3.2,8.9,5.8,11.6,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M702.3,462.8c4.4,0,5.4,3.2,9.5,3.1.9-3-2.3-2.1-3.1-3.7s.3-1.9,1.5-1.5c2.6.7,3.5,3.9,4.5,4.2,4.6,1.3,11.6-1,10.8,7.4,3,1,1.8-2.3,3.8-3s4.8-.7,5.7.9c-3.5.6-6.6,2.7-7.4,6.3-4.6.7-11.8,2.1-15.8-1.1s.1-1.5,0-2.1c-.7-3.5,2.5-1.6,4.5-2.1s2-3.8,6-2.1c-.3-1.7-1.8-1.8-3.2-2.1l-.5-1-.5,1c-4.7-.1-4.2.9-7.4,2.1-4.6,1.8-8.6,5.7-13.7,1.6s-3.3-3.1-1-3.8c0,0,1.6,0,2.1,0,1.1,0,1.5-.8,2.1-1.1,1.3-.6,2.8,1,2.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M747.5,473.3c2,1.9,1.2,3.2,5.3,3.2s2-.4,2.6-1c.7.8-.6,2-.5,3.1-1.7.2-3.6-.2-5.3,0-4.6.7-3.9,3-4.2,3.2-5.9,3.4-16.3,3.8-15.8-5.3,1.6,2.5,5.9,1.7,7.3,0s-2.6-1.6-2.1-3.1c5.9-.9,8.1,1.1,11.5,5.2,1.8-4.5-2.1-5.4-2.1-5.8s1-.4,1-.6c.6.4,1.7.6,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M524.7,458.6c5.3-6.4,14.1-11.3,21.5-14.8,36.5,1.8,74.3,2.8,109.9,8.5-2.5-1-9.8,1.8-12.6,2.6,3.9,4.9,7.8.2,11,.5s2.7,2.6,4.8,2.1c.7-.7-2.9-5.1-3.1-5.3,3.1.5,6.4,2.4,9,1.1.5.7-.6,2-.6,2.1-1.9.9-4.6,1.6-4.2,4.2,2-.2,4.3.2,6.3,0,3.1-.4,1.5-2.7,4.7-2.1l5.3,4.2c-2,2.1-11.7,2.2-13.2,1s.1-4.3-2.1-2.1,2,1.9,2.1,2.1c.4.5-1,2.5,1.3,3.5,5.7,2.6,9-1.9,11.8-1.5s1.2,2.7,2.8,3.7c4.3,2.9,9.8,1.5,13.6-1.5,1.7,9.3,11,8.4,17.9,5.3,0,.4,0,.7,0,1.1.2,1.1.7,1.4,1.1,2.1,3.7,7.2,9,3.5,15.8,3.2,0,.4,0,.8,0,1.1,1.1,4.8,5.4,6.2,10,6.4s5.3-2.9,7.4,2c3.6.5-.7-5,.5-6.3,1.9-.6,1.9,1,2.1,1.1,1.8.6,1.3.3,3.2,0,2.1-.3,4.9.4,6.8,0s-.5-4.4,2.7-3.2c1.7.9,3.3,1.9,5.3,2.1,0,4-6.5,2.5-.5,7.3.2-2.7,7.5-4,8.7-2.9s0,1.7.2,1.9c-4.3,4.3-12.7,5.5-18.7,7.1s-5.1,0-5.5.3c-38.9-19.2-83.5-28.2-126.7-32.6-7.6-.8-22.7-3.1-29.5-2.2s-13,5.5-18.3,6.9c-7.2,2-15.7,3.1-23.1,3.6l28.4-11.5c-18.4-1.6-37.2-1.2-55.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M307.1,467l-21.1-57.2c12.8-6.8,27.3-8.4,41.1-12.2l17.9,58.9c-12.6,3-25.6,6.2-37.8,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M372.3,376.6c4.5,2.5,9.4.1,14.1,0s12.2-.2,17.9,0,3.9-.8,3.7,1c-1.8,0-3.7-.1-5.5.3-19.5,4-39.4,7.2-58.8,11.6-29.1,6.6-77.2,18.1-102.5,32.1s-7.4,6-5.6,1.8,9.1-9.3,10.6-10.4c22-16.7,64.4-28,91.4-33.2l-1.6,2.1c5.5-.8,11.1-1.5,16.6-2.3s2.6-1.9,2.8-1.9c4.9-.8,11-.3,16.8-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M768.5,399.7c-.6,2.5,1.3,2.2,2.8,3,12.2,6.5,5.7,3.7,0,7.7s-1.6,3-2.3,3.1c-1.5.1-16.9-5.9-20.4-6.9-8.9-2.5-22.4-4.3-30.3-7.6-3.6-1.5-6.3-4.5-10.3-6.5-5.2-2.5-11-3.5-16.1-6s-2.6.3-2.1-2.6l35.1,5.3c1.2-.2.4-1.9.6-2.2s.7,0,1.1,0c.5-.1,3,0,3.2,0,4.4,3.1,7.8,2.8,13.9,4.5,8.4,2.4,16.8,5.3,25,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M355.4,454.4c32.3-6.9,65.2-11.3,98.3-13.7,9.8-.7,20.1-.7,29.9-1.1-.9,1.9-2.7,3.8-4.8,4.2-41.5,1-82,8.8-122.4,15.8s-2.9-.2-4.2,0l-1.1,1.1c-.9.2-2.1-.1-3.2,0s-.9.6-1.1,1.1c-.3,0-.7,0-1.1,0-15.9,2.2-34.4,9.3-49.4,14.7,1.3-6.7,10-5.2,14.7-6.8,9.7-3.3,21.4-8.8,31.5-10.6s9.2.5,12.7-.4l-3.2-1.6,3.2-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M787.4,482.7c-1.2.6-2.6,1.4-4.2,2.1-10.2-7-22-11.2-33.6-15.3-1.5-.5-3.3-.2-4.2-.5s-2.1-.7-3.2-1.1-1.4-1.5-2.8-1.9c-39.7-12.3-81.1-17.5-122.3-22.3l2.7-3.2c55.4,6,113.7,13.6,163.8,39.1,1.5.8,3.1,1.3,3.8,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M812.7,470.1c-7.2,4.7-12.3,6.9-20,10.5,4.7-3.3,3.5-5,5.2-9,5.5-12.8,14-25.2,15.8-38.9s0-2.6,1.6-3.6c3.8,1.2,11.5,16.2,11,18.3s-2.7,1.6-3.5,2.8l-10.1,19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M355.4,376.6c54.1-9.1,108.9-14.3,163.8-14.6l1.2,4c-15.5.8-31.3.2-46.8,1-33.9,1.7-67.8,4.9-101.4,9.5s-11.9.3-16.8,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M832.6,428.1c-1.9.6-3.2,1.7-5.3,0-13.2-12.2-41.9-22.6-58.9-28.4-8.2-2.8-16.6-5.7-25-8.1-6-1.7-9.5-1.4-13.9-4.5,2.8.2,2.4,0,1.1-2.1,27.1,5.5,84.5,22,102,43.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M639.2,368.2c3.3,1.8,7.9,1.7,11.6,2.1s.7,0,1.1,0c3.5,2,8.6,1.7,12.6,2.1s.7,0,1.1,0c3.5,1.9,8.6,1.8,12.6,2.1s.7,0,1.1,0l35.3,8.4c1.1.3,2.6-.1,3.6,0,2.3,2,5.6,1.8,8.4,2.1s.7,0,1.1,0c.8.1,1,0,1.1,0,.6.1,1.5-.1,2.1,0,1.3,2.1,1.8,2.3-1.1,2.1-.1,0-2.6-.1-3.2,0-.1-.5-.6-1-1.1-1.1-1.3-.2-2.9.1-4.2,0-.1-.5-.6-1-1.1-1.1-1-.1-2.1.1-3.2,0l-.5-1-.5,1c-34.3-5.5-68.4-12.7-103.3-14.7-1.1-.3-1.9-3.1-2.9-4.2,9.8,1.3,19.6,1.5,29.4,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M220.9,426c0,0,1.4.3,1.8-.3,1.4-1.9.9-5.3,5-6s.3,3.1,0,4.2.5,1.1.5,1.1c-1.8,5.7-5.8,11.5-3.7,17.9,4.8-6.4,11.5-13.3,18.4-17.4,1.4-.8,2.2-2.1,4.2-1.5-5.7,5.5-10.9,10.6-15.8,16.8-5.6,7.2-3.1,12,0,20-3.9.7-12.9-12.9-13.4-15.5-1.3-5.7-.3-14.3,2.9-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M712.8,374.5c-20.4-1.1-40.7-3.6-61-5.3s-8.8-.8-12.6-1.1c-9.8-.6-19.6-.8-29.4-2.1-1.6-1.8-2.1-2.8-3.2-4.2,35.5,2.9,71.4,5.2,106.2,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M355.4,454.4l-3.2,2.6,3.2,1.6c-3.5,1-9.7,0-12.7.4-10,1.8-21.8,7.3-31.5,10.6s-13.4.1-14.7,6.8c-1.2.4-2.7,1.9-4.2,2.1-1.2-3.7-6.1-1-9.5,0,6.5-5.3,16.3-8.8,24.2-11.6,12.2-4.3,25.3-7.5,37.8-10.5,3.5-.8,7-1.4,10.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M274.5,393.4c-16.3,9.2-34.2,16.5-46.2,31.5,0,0-.7-.4-.5-1.1.2-1.1,3.5-4.8,0-4.2s-3.6,4.2-5,6-1.7.2-1.8.3h-1.1c5.6-7.1,12.1-11.2,18.9-16.8,1.8-1,3.6-2.3,5.3-3.2l.5,1c3.8-1.8,7.4-4.4,11-6.3,7.4-3.8,11.3-4.8,18.9-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M832.6,428.1c5,6,7.7,11.2,9.5,18.9-2.3,5.2-7.3,8.5-11.1,12.6-3.6.2-.6-3.5-.5-4.2,8.3-8.6,4.9-19.9-3.2-27.3,2.1,1.7,3.3.6,5.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M608.8,439.6c.2,4.1-5,3.3-7.9,3.2-15-.5-30.1-1.6-45.2-2.2-1.4,0-4.4.9-3.7-1.6s50.8,1.6,56.8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M745.4,469.1c0,1,.1,2.1,0,3.2s-1,.3-1,.6,3.9,1.3,2.1,5.8c-3.5-4.1-5.6-6.1-11.5-5.2-.5,1.6,4.1.8,2.1,3.1s-5.7,2.5-7.3,0l-2.1,3.2c0-.3,0-.7,0-1.1,0-.6-.1-1.6,0-2.1.8-3.6,3.9-5.7,7.4-6.3s8.3,1.6,7.4-2.1c1.1.3,2.1.7,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M282.9,478.5c3.4-1,8.3-3.7,9.5,0l-13.7,8.4c-2.8-1.1-4.7-2.4-6.3-3.2,3-3.5,6.6-4.1,10.5-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M600.3,369.2c-2.5-.8-5.9,1.3-7.7,1.1s-.6-1.9-1.4-2.1c-4.6-1.1-14.8,3-14-4.2,6.1,1.2,21.4-1.9,23.1,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M692.8,464.8c-.2.2-4.8,2.6-5.2,2.7-4.5,1.5-8-.4-9.5-4.8,5.8,1.8,6.2-2.1,7.5-3,2.2-1.4,8.5,3.2,7.2,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M231.4,442.8l-1.1,3.2c-.4,7.1,2.7,12.9,7.4,17.9-4.5,1.7-4.8.7-6.3-3.2-3.1-8-5.6-12.7,0-20,0,.7,0,1.4,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M356.5,459.6c0,.8-.9,1.7-1.1,2.1-9.5.3-4.6,9.4-13.7,6.3s-1.9-1.3-3.1-1.1v-1c2.8-1,7.5-.4,7.4-4.2.3,0,.7,0,1.1,0,.5-.1.9-.6,1.1-1.1,1-.1,2.2.2,3.2,0s.8-1,1.1-1.1c1.3-.2,2.9.2,4.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M362.8,464.9c-1.2.7-2.4,1.1-3.7,2.1s-1.2,2.9-2.3,3.2c-5.9,1.5-12.1-2.9-3.5-4.2,1.2-.2,2.9.5,4-.2s2.1-6.3,5.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M355.4,376.6v1.1c-.2,0-1.3,1.7-2.8,1.9-5.5.8-11.1,1.6-16.6,2.3l1.6-2.1c6-1.1,11.7-2.1,17.9-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M718.1,467c.3,0,.7,0,1.1,0,1.4.2,2.9.4,3.2,2.1-4-1.7-5.5,2-6,2.1-2.1.5-5.2-1.3-4.5,2.1h-1.1c0-.3,0-.7,0-1.1,0-1,0-2.1,0-3.2,3.1-1.2,2.7-2.2,7.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M379.6,461.7c-4.1.5-10.6,6.7-9.5,0,2.9-1.1,6.7-4.9,9.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M696,467c-.4-.4,1-3.2-2.1-1-1.2-2.9,2-4.7,4.6-4.3s-1.6,1.1,3.8,1.1c.7,4.2-.8,2.6-2.1,3.2l-2.1,1.1c-.5,0-2,0-2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M453.2,448l1.1,2.1c-3.6-1-10,5.2-9.5,0,2.4-.4,4-1.8,8.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M664.5,455.4c.1.2,4.5.4,2.1,4.2-2,.2-4.3-.2-6.3,0-.4-2.6,2.3-3.3,4.2-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M230.4,445.9l1.1-3.2c0,2.4-1,3-1.1,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M717,385c-.3,0-.7,0-1.1,0l.5-1,.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M248.8,422.8c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M234,424.9c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M726.5,387.1c-.4,0-1-.1-1.1,0v-1.1c.5,0,.9.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M721.2,386c-.5,0-.9-.6-1.1-1.1.5,0,.9.6,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M271.3,1111.3c-.3-.2-.8-.7-1.1-1.1.3.4.7.7,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M256.6,547.9c.7.8,1.9,5.9,4.7,5.3s.2-4.5-1.6-5.3c3-2,4.5,3.6,5.8,4.2-.2-2.8,3.9-2,4.7-1,1.6,2-3.1,2.9-3.2,3.8s1.4,3.1,1.1,4.6l5.2-5.2c4.8.2,6.8,3,5.3,7.4l5.2-1.1c.6-1.4-4.4-1.1-2.1-3.1s4.4,2.2,5.2,3.1c-2.2,4.8-2.4,4.3-7.4,3.2-.4,2.9.9,4.6,3.7,5.2,7.2,1.5,3.2-2,5.7-6.3.9,3.5-2.1,5.8,4.2,6.3-2.8,7.2,7.5,10.4,9.5,3.2l2.6,3.2c.2-5,6.9,2.3,6.8-3.2.9,2.2,4.9,3.8-1,5.3-.3,1.8,2.7,1,3.1,2.7s-1.4,3.2-1,3.6c6.1-.4,13.7-5.5,3.1-6.3l2.1-7.3c6.2,2.1,5.6,2.8,5.3,9.5,2.5.7,2-1,3.1-2.1-.3,2.8,5.7,5.8,7.4,4.8,3.8-3.5-3.2-6.4-6.3-5.8.5-.6,2.3-3,2.1-3.1-4.6.6-5.7,2.6-6.3-3.2,2.1,1.5,4.6.6,6.6,1.1s-.1,2.5,3.9,2.1c-3.7,5.3,3.7,2.3,6.7,3.3s3.3,9.3,8.1,6.1c-1.6,4.3,6.2,5.1,7.2,1.3s-.8-2.8-.4-3.5c2.6-4.5,12.2,5.2,13.2,4.2.5-3.4-2.7-4.1-4.2-6.3,2-.6,2.6,1.7,3.9,1.9s7.7-5.1,9.8.1c-6.1.3-9.6,4.4-8.4,10.5.4.5,8.1-2.3,8.4-3.7s-2.7-2.7-2.1-4.7c4.6-.7,6,.1,9.5,2.1-6.8-1.1-8.6,9.5-5.3,13.7l-2.1,3.1h3.1c-1.2.4-2.4,1.5-4.1,1.1-1.6,1.5,7.4,36.7,8.3,42,12,66.5,15.7,136.9,10.5,204.4-5.1,66.3-20.4,131.1-26.3,197.1s-1.3,13.7-2.1,19.5.6,1.8-1.6,1.5c-18-10.9-32.9-24.6-44.7-42-1.7,14.5-4.1,28.8-3.2,43.5,6.7,2.2,13.1,6.8,19.7,8.8,14,4.2,28.7,8.2,43.4,10.7.3,0,1.1.9,2.1,1.1l-1,4.2c3.8.1,6-1.4,5.3,3.2-1.4,0-2.8,0-4.2,0-4.9,0-13.4-.7-18.9-1.1s-10.2-.4-15.8-1.1c-15.1-1.7-28.7-6.2-43.1-10.5,0,2.5-.4,4.9.6,7.3s8.5,12.5,9.9,14.2c6.7,8,22.9,17.3,32.7,20.9,10,3.7,24,6.1,34.6,8.5s3.4,0,3.1,1.6c-13.3-.4-26.3-4-39.4-5.2s-20.3-1.3-21.5-.5-.7,1.8-1.4,2.3-5.4.8-2.8,3.4,2.9,0,4.2.5,3.6,1.8,5.2,2.7c3.5,1.8,6.9,4.5,10.5,6.3v2.1c-4.1-1.6-8.6-3.5-12.6-5.3-18.1-8-31.9-16.9-48.4-27.3s-4.2-2-6.3-3.2c-.3-.4-.7-.7-1.1-1.1-1.8-2-2.5-2.6-4.2-4.2-.3-.4-.7-.7-1.1-1.1s.2-1.1-1.1-1.1c-1.7-2.5-3.6-5.9-5.3-8.4s-3.6-4-4-7.9c-1.1-11.2-4.8-26.2-6.5-39.4l2.1-.5c-1.6-3.6-.4-8.1-3.2-11,.3-19.2,1.6-31.7,5.3-50.5.3-1.7.8-3.6,1.1-5.3s0-1.4,0-2.1c1.5-.9.8-1.1,1.1-2.1,1.2-4.1,1.8-8.5,3.2-12.6s.6-.7,1.1-2.1c6.1-18.8,11.8-37.7,17.6-56.6,2.7-8.9,8.4-21.4,8.7-30.7s0-1.5,0-2.1l1.1-2.1c.1-.1.9-1.7,1.1-2.1,3.7-13.4,6.4-27.3,8.4-41h2.1c-3.5,31.1-10.3,63-16.8,93.6s-8.6,35.2-11.6,53.1c-.1.9,2,.6,2.1.5.5-.4,4.4-10.6,5-12.3,6.5-17.4,14.2-30.6,22-47.4,11.4-24.3,23-49.8,32.3-74.9,1.6-4.2,3.4-13.5,5.3-16.8s1.4-1.3,1.6-1c.3,4.7-.3,9.5,0,14.3s1.1,2.4,1.1,2.6c0,1.4,0,2.8,0,4.2-3.2-1.1-2.3,4.5-2.1,7.4s0,2.1,0,3.2c-1.6.7-1,2.8-1.1,4.2s-.1,2.8,0,4.2c-1.6.7-1,2.8-1.1,4.2-.9,12.8-6,32.5-9.5,45.2-2.6-.2-2.7,1.6-3.7,3.1-13.6,19.9-24.5,40.5-41.6,58.2s-2.2.4-3.1,1.4c-1.2,1.4-2,6.7-4.7,7.7s-.4-3.5-2.6-3.1c1.1,4.6-.1,8.6,0,13.2s1.8,6.5,1.1,9.2-6.2,5.9-7.5,6.6c-.6,3.8,4,4.1,4.3,5.4,3,13-1.7,16.5,8.4,29.2,8.1,10.2,20.4,16.2,32,21.6,0-6.9-3.1-13.6-3.7-20.5s.4-14.3,1-21.5c4.5-53.1,32.6-113,42.8-168,15.8-84.7,6.1-187.6-24.2-268.5-.5-1.4-1.4-3-2.3-4-3-.9-2.9,4.3-8.9,3.8-8.4-.8-9.8-8.1-12.2-8.9s-2.9.9-3.5,1c-8.1.2-11.1-7.3-12.3-7.4s-2.8,1.4-5.3.4-3.4-4.4-4.5-5-4.6.7-6.3,0l7.3,18.4c3-1.2-.6-6.3-1-7.9-1.1-4.4,8,2.9,8.9,3.7,15.3,13.1,31.9,49.7,36.8,69.4,11.4,46.2,5.3,94.6-6.9,139.8-1.8.2-1-2.4-1-3.7-.3-7,.2-14,0-21.1s-1-1.5-1-1.6c0-1.7.1-3.5,0-5.3-.2-3.7,1-8.7-1.1-11.6-1.7-36-8.6-70.8-18.6-104.9s-11.8-31.7-19.8-46.4c-1,0-.6,1.7-.4,2.5.8,5,3.6,15.4,5.2,20.6h-1.1c-8.5-26.9-19.2-53-30.5-78.8,2.7,2.4,6.1,5.7,8.4,8.4ZM266.1,563.7l3.1.5-1-2.6-2.1,2.1ZM280.8,587.8c.8-1.5-.7-2.8-1-2.1-.8,1.5.7,2.8,1,2.1ZM336.5,591c3,3.1,10.3-.7,10.5-5.2-2,.4-2,3.5-3.8,4.1s-9.9-2.2-6.6,1.1ZM355.4,1009.4c14-71.5,24.7-143.9,22.1-217.1l-3.2-34.1-6.4,65.5c-7.3,56.1-24.1,110.1-39.8,164.2-1.2,4.5,3,4.2,6.2,6.3,6.7,4.4,12.3,9.8,18.5,14.1.9.6,1,1.5,2.6,1ZM278.1,1091c-4.5-5.8-10.2-10.6-13.9-17.2l-8.6-20.3c.3,8.4,4.8,20.7,9.6,27.7s12.4,14,14.5,12.3c.8-2.6-1.2-1.8-1.7-2.5ZM308.1,1128.1c.8-.8-3.2-6-4.2-6.9-3.3-3-6.7-2.9-9-4.6s-15-14.7-17.8-17.9-3.4-8.1-7.8-8.4c4.8,18.1,21.8,31.7,38.9,37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.2,1106.1c.4.3.7.7,1.1,1.1.4.7.3,2.2,1.1,3.2,0-.1-1.3.2-1.8-.3-1-1-3.7-4.8-1.4-5,.3.4.7.7,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M327.1,577.3c.1-1,.2-.9,1.1-1.1-.3.4-.7.7-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M273.5,1111.3c.2,0,.5.7,1.1,1.1,1.5,1.5,2.6,2.7,4.2,4.2,14.4,13.4,30.5,20.2,48.4,27.3,4.3,1.7,17.8,8.7,21.6,8.5s1.3-1,1.5-1.1-.2-.9,0-1.1c.5-.4,4,1.4,0-4.2v-3.2c4.7-.2,9.6,1,14.7,1.1h95.7c2,.2,4.3-.2,6.3,0,17.2,1.9,31,2,48.4,2.1,32.2.2,64.5-.7,96.7-1.1,2.1,0,4.2,0,6.3,0s1.4,0,2.1,0l89.7-.9,1.7,1.4c-.3,3.9-4.5,1.2-7.9,1.4s-5.2,3-8.9,1.2c2.1,8.3-6.9,5.6-8.4,11.6-10,3.2-23.4,7-33.6,9.5-77.5,18.4-151.3,13.9-229.1,3.2-.2,0-1.1-.9-3.2-1.1s-1.4,0-2.1,0l-43.1-11.6c-2.9-3.4-7.7-3.2-11.5-5.9s-3.9-8.8-11.6-5.7c3.3,7.2,12.7,7.3,18.9,11.6-3.5-.5-6.9-1.9-10.5-2.1-.3,1.9,1.8.6,2.8,1.4s1,2,2.4,2.8c-3.2.2-6-1.1-9-2.1-13.2-4.5-26.8-9.4-39.4-14.7-19.8-8.5-32.9-16.5-46.2-33.6.4.2,1.6-.2,2.1,0ZM426.9,1158.6c.6-3-1.7-2.2-3.7-2.1-4.5.1-8.6,1.4-13.1,1.1-.3,1.9,1.8.6,2.8,1.3,4.5,3.1,3.7,2.5,9.8,3.9,1.2.3,2.3.9,3.2,1.1-.3,3.3-.4,2.7,2.3,3.5s8.6,2,12.3,2.5c40.2,6,85.8,5.3,126.3,3.5,2.1,0,4.2.1,6.3,0,25.4-1.4,55.1-2.9,78.6-12.4,1.3-.5,3.1-.2,4.5-.3.2-2.6.2-1.8-1.6-2.1s-5-.7-7.4-1-1.8.4-1.5,2c-1.4,0-2.8,0-4.2,0,0-.6.2-1.9,0-2.1-.6-.4-12.6-2.1-13.7,0-2-.2-3.9-.9-6.3-1.1-45.4-3.7-93.8-3.8-139.2-2.1-16.7.6-39.4-.3-55.2,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.1,912.7c-3.1,11.4-7.4,23.7-12.4,34.4-8.6,18.3-29.5,41.7-20,62.7,2.1,4.6,7,12.5,12.5,13.3-.6,7.2-1.7,14-1,21.5s3.6,13.7,3.7,20.5c-11.6-5.3-23.9-11.4-32-21.6-10.1-12.7-5.5-16.2-8.4-29.2-.3-1.3-4.9-1.6-4.3-5.4,1.3-.7,7.3-6.1,7.5-6.6.7-2.7-1.1-6.3-1.1-9.2,0-4.5,1.2-8.6,0-13.2,2.2-.4-.3,4.2,2.6,3.1s3.4-6.3,4.7-7.7,2.5-.8,3.1-1.4c17.1-17.7,28.1-38.3,41.6-58.2,1-1.5,1.1-3.3,3.7-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314.4,763.4c0,0,1,0,1,1.6.3,7-.2,14.1,0,21.1s-.8,3.9,1,3.7c12.2-45.2,18.3-93.7,6.9-139.8-4.9-19.7-21.5-56.3-36.8-69.4-.9-.8-10-8.2-8.9-3.7s4,6.8,1,7.9l-7.3-18.4c1.7.7,5.7-.4,6.3,0,1.1.6,1.7,3.9,4.5,5s3.8-.6,5.3-.4,4.1,7.6,12.3,7.4c-4.5,2.5-.6,1.7,1.1,3.7,3.7,4.4,4.3,8.1,6.2,11.9,33.7,70,48,142.2,14,215.4-3.3,7-7.2,14.1-11.7,20.3l5.2-66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M238.8,409.2c-6.8,5.7-13.4,9.7-18.9,16.8-24.8,31.9,24,51.7,46.2,62,22.2,10.3,40,15.5,63.9,20.7,44.5,9.7,90.3,14.5,135.8,17.2l-3.1,2.1c-1,0-2.1,0-3.2,0-7-2.4-14.9-1.7-22.1-2.1s-6.3.2-9.5,0-2.1-.9-4.2-1.1c-56.7-4.3-114.1-11.2-167.1-32.6-21.4-8.6-56.9-24.6-52.6-52.6,9.6-16.8,18.5-21.6,34.7-30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.8,840.1c0-.1-1-.3-1.1-2.6-.3-4.7.3-9.5,0-14.3-.2-.3-1.3.5-1.6,1-1.8,3.3-3.7,12.6-5.3,16.8-9.3,25.1-21,50.6-32.3,74.9s-15.6,30-22,47.4c-.6,1.7-4.5,11.9-5,12.3s-2.2.4-2.1-.5c3-17.8,7.8-35.4,11.6-53.1,2.2.5,3.7,1.8,5.8,0,1.4-1.2,7.7-11.6,9.1-14,11.9-20.4,21.9-42.8,31.1-64.5,5-8.9,7.6-30.8,12.3-38.1s1.3-1.4,1.6-1c-.2,5.4.3,10.9,0,16.3s-1.2,13.6-2.1,19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234.6,494.3c.6.1,1.5-.2,2.1,0,3.9,4.4,4.5,3.9,9.5,6.3s1.3.7,2.1,1.1c15.7,7.4,30.4,10.9,46.2,16.8s7.5,2.9,9.5,4.2c-4.4,0-9.4-1-13.7-2.1-10.1-2.7-26.3-6.9-35.7-10.5s-.8-1.5-1.4-1.8c-2.7-1.1-21.9-9.4-21.8-10.9s1.4-1.2,1.1-2.1c-4.9.7-2.5-1.6-3.2-3.2,1.9-.1,3.8,1.8,5.3,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.6,492.2c2.8,3.3,7.9,6.8,11.7,8.8,6.3,3.3,13.1,5.6,19.9,9-11.6-.4-22.5-7.1-33.6-9.5-2.9-2.6-7.7-3.6-11.6-4.2-3.5-2.4-3.3-1.3-6.3-2.1-.3-.4-.7-.7-1.1-1.1-4.2-4.5-13.6-8.3-18.9-12.6s-6.3-6.1-8.4-8.4c-5.5-6.1-8.2-13.2-8.4-21.6-.2-6.2,1.8-6.7,4.2-11-4.4,27.9,31.2,43.9,52.6,52.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.3,536.3c6.8,5.7,14.8,11.2,23.1,14.7v3.2l-5.2,5.2c.3-1.5-1.2-3.6-1.1-4.6s4.7-1.8,3.2-3.8-4.9-1.8-4.7,1c-1.3-.6-2.8-6.2-5.8-4.2-.6-.3-2.3.2-3.2,0-2.3-2.7-5.7-6-8.4-8.4-.7-1.6-.7-3.4-1.1-4.2h1.1c.8.9,1.3.7,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.4,497.5c-.2,1.5,19.1,9.8,21.8,10.9s1,1.6,1.4,1.8c3.4,10.8,8.8,20.6,14.2,30.4,1,1.8,2.2,2.8,1.5,5.3-6.9-3-13.3-6.7-20-9.5-.6-.5-1.3-.9-2.1-1.1-2.4-2.8-3.5-10.3-7.4-12.6-3.6-7.9-8.2-15.5-11.7-23.5s.4-1.4,2.3-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M297.6,685.6c8.2,39.4,14,77.7,4.7,117.7,0-19,1.4-38.3.6-57.3s-3.2-42.3-6.4-60.4h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M279.8,618.3c0,.3,1.5,1.4,1.9,2.8.8,2.8,11.7,39.2,9.2,39.3-4.3-13.9-7.7-28.2-12.1-42.1h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M235.6,493.2l-1.1,1.1c-1.5-.3-3.3-2.2-5.3-2.1-1-2.3-6.1-4-8.4-5.8s-3.6-4-5.3-5.7h1.1c5.3,4.3,14.7,8.1,18.9,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M297.6,685.6h-1.1c0-.4-1.4-1.7-1.6-3.1s-4.7-21.1-3.1-21.1c2.6,7.9,4.1,16.1,5.8,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.8,828.6h-2.1c.3-2.3-.2-5,0-7.4l3.1-12.6c.3,6.7-.3,13.4-1,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M250.3,536.3c-.8-.3-1.3-.2-2.1-1.1.8.1,1.5.5,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M368.1,533.2c-4.5.3-9.1,1.2-13.7,1.1l13.7,38.9c-3.7-.3-7.4,0-10.5,0s-3.5,0-5.3,0c.7-3.2-1.6-1.9-4.2-2.1s-.7,0-1.1,0c-.3-.9-1.2-1.1-2.1-1.1s-1.4,0-2.1,0c-4.7-1.8-9.8-2-14.7-3.2-15.4-3.5-40.7-9.9-54.7-15.8-8.3-3.5-16.3-9-23.1-14.7,6.7,2.8,13.1,6.5,20,9.5s19.3,7.7,29.4,10.5c3.1.8,5.8,2.9,9.5,2.1,1.8-1.7-10.6-21.6-10.5-24.7s11.1-7.2,5.2-11-7.1-3.3-9.5-4.2l73.6,14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M248.2,535.3h-1.1c-1.5-3.5-4.4-8.4-6.3-12.6,3.8,2.3,4.9,9.8,7.4,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.8,844.3c.1,2.9,1.1,8.4-2.1,7.4-.2-2.9-1.1-8.5,2.1-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M314.4,758.1c-2.1-2.8-.9-7.9-1.1-11.6,2.1,2.8.8,7.9,1.1,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.7,480.6h-1.1c-.1-.1-1.3.2-1.8-.3-1.9-1.9-4.3-5.6-5.6-8.1,2.1,2.3,6.1,6.6,8.4,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.7,854.8c0,1.3,3.4,4.8-1.1,4.2,0-1.4-.5-3.5,1.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.6,863.3c0,1.3,3.4,4.8-1.1,4.2,0-1.4-.6-3.5,1.1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255.6,400.7c-3.7,1.9-7.3,4.5-11,6.3l-.5-1c3.7-1.9,7.4-4.1,11.6-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M772.7,564.7l-1,.5c0,.5,0,1.1,0,1.6.5,2.7,2.6.2,3.2,0,.9-.3,1.5-.8,2.1-1.1,1.3-.5,2.6-1.4,4.2-2.1-.7,5.9,7,5.9,6.3,0,.4.2,1.7-.2,2.1,0,1.1.7.6,2.5,2.1,2.1v-2c.8-.1,1,1,1.1,1,1.4,4.6-5.4,3.9-8.4,5.3s-8.4,6-9.2,6.2c-2,.5-4.2-1.3-5.6-.5s-1.5,3.7-2.6,4.8c-4.2,4.3-13.4.6-14.1,1.1s-.8,5.4-5.3,6.8-6.1-.7-7.8-.4-2,3.8-4.7,4.6-6.3-1-9.6.4c.9-2.1,1.7-4.4,1.1-6.7s-2.1-.6-2.1-.7c-.7-.9-.4-3.5-2.8-4.1-5-1.2-5.8,4.9-3.9,5.1h6.7c2.8,5.9-4.3,10.3-9.7,9.2-2.6-.5-4.6-3.2-7.1-3.5,1.5,6.2,13.2,6,16.8,2.6,2,1,.7,3.5.3,5-2.3,8.7-6,17.4-8.4,26.3-25.7,96-13.5,193.9,12.8,288.2,8.9,31.7,20.5,62.7,28.9,94.6,4.4-4.6,7.5-12.8,8.9-18.9,11.8-50.1-17.9-106.3-29.3-154.7s-8.1-43.9-11.2-66l-6.3,3.1c-4.1-18.3,1.8-35.5,4.1-53.2,5.3-41.7,8.6-68.5,26.2-107.3,1.8-4.1,12.5-24.9,15-26s10-3.1,10.5-2.7c.5,6.8-3,12.3-5.3,18.1-4,10.3-6.9,21.5-9.1,33.1-5.6,29.4-10.5,60.7-12.9,90.6-1.9,23.5-3.1,47.9-2.1,71.5.4,9.9,2,19.7,3.2,29.4s.8,4.4,1.1,6.3c9.7,73.2,45.4,142.4,32.5,215.9-1.7,9.9-5.3,20.4-9.3,29.6,2,1.5,11.5-7.8,10.4-3.2s-3.5,6.2-4.8,8.9l-17.2,22.2c12.6-3.1,20.2-11.5,26.7-22.2,8.4-13.8,13.2-28.6,15.3-44.7,1.8-14.1,1-28.3,1.2-42.4l-7.3,10.5c1.6-6.7,3.9-14,4.9-20.8,2.9-18.7-1.9-36.5-5-54.9l-1.1,3.7,1.1,13.1c-13-25.5-26.9-53.4-33.8-81.4-.4-1.7-1.5-3.3.2-4.8,3,8.5,7.2,16.1,10.7,24.6l16.7,30.1c-3.6-19.2-9.9-37.7-13.7-56.8-2.2-11.3-4.3-23.1-6-34.5-.3-1.7-1.1-4.4.8-5.5,8,43.6,26.1,84.9,34.4,127,2.5,12.6,2.7,25.2,2.4,38.1,0,.7,0,1.4,0,2.1,0,1.2-.3,2.6,1.1,3.2-.1,1.4,0,2.8,0,4.2s0,2.8,0,4.2c0,4.9,0,9.8,0,14.7v23.1c-.3.4-.7.7-1.1,1.1,0-2.1,1-7.3-1-8.4-1,17.9-4.4,36.1-9.2,53.4s-2.4,4.8-3.2,7.3c-3.7,11.9-2.2,17-12.9,26.5-7.6,6.8-17.6,12.6-26.3,17.9,1.3-4.8,6.6-5.7,10-8.4,8.3-6.7,11.2-10.3,16.5-19.3s2.6-2.6,3-3.3c2.3-5.3-8.5,4.2-9.1,4.6-7.3,5-7.1,5.8-13,11.2-9.3,8.6-21.2,14.3-30.5,22.6-1.4.8-4.3.6-5.3,1.1l1-6.3-26.3,4.2c.2-1.6,3.6-2.3,5-2.9,2.8-1.1,6.6-1.5,8.7-2.4.7,1.9,3.3.2,4.5-.3,14.3-4.9,24.3-5.1,35.8-15.2.8-.7,7.5-2.9,4.9-5.6s-8.3,3.4-10.5,3.7-3.3-.7-4.6-.6-3,4.1-4,4.6c-4.6,2.5-11.7,5.5-16.7,8-1.4-1.1-4.8,0-6.5.3-14.6,2.7-32.1,7.9-46.6,9.1s-34.9,0-51,0c-1.1,0-2.1,0-3.2,0,1.9-1.3,5.6-1.9,7.9-2.1,13.6-.9,27.2-1.7,40.7-2.4,3.1-.2,28.2-8.7,32.6-10.5,3.7-1.6,25-14.6,26-17.1s-1.4-1.5-2.6-1.6c-12.7-.9-19.8,1.2-31.8-3.1-11.4-4.1-33.1.3-45.4,1l46.8-18.9c3.7-18.2,2.6-36.8.4-55.1-.3-2.3-1.7-4.5-2-6.9-.6-4.6-3.4-22.3-3.2-25.2s3.1-2.5-1.1-2.1c0-.6,0-1.5,0-2.1,1.4-10.8-1-16.7-2-26.9s-1-3.8.9-3.5c4.6,10.7,12.2,19.7,18.1,29.8s8.6,17.4,9.3,16.5c-4.6-30.6-12.1-60.7-17.6-91.2-17-95.1-27.8-194.1-7.3-289.5,1.7-7.8,6.6-20.2,7-27.1.1-2.5-2.1-5.1-4.2-6.3l-1.1-5.3c2.4-.7,5.8-3.2,8.8-2.9s4.3,3.2,4.8,2.9,3.8-6.6,7.1-8.2,12.5-.8,12.9-1.3c1-1-2.6-5.6,4.2-4.2l-1,7.3c3,.6,2.5-2.2,3.1-3.1-.7-.2-2.1.5-2.1-.5.6-1,3.8-6.3,5.2-4.7s-2.4,4.2-3.1,5.3c1.8.4,5.4,2.2,5.7,2.1,3.4-.6,1.2-13.2,11.1-5.2-1.3,3.3-7.1,4.1-7.9,5.2-2.7,3.7,4.6,6.3,8.2,3.3s2-4.4,2.9-6.4,1.2-1.8,1.1-3.1l2,1c5.5,5.4,12.8,3.6,13.7-4.2-1.7,0-3.5-.1-5.3,0l2.1-3.7c-3.2-1.6-6.3.5-9.5.5,2.3-5.4,8-1.4,10.8-2.2s2.4-4.4,4.9-4.7,1.8,1.6,2.1,1.7ZM786.9,1099.8v1.1c.7-.4.7-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1050.2,872.7c-20.5,30.5-55.2,64-83.6,88.3-35.9,30.7-76.6,57.2-106.6,94.1-7.3,9-16.9,27.3-27.4,31-1.8.6-3.3,1.4-5.3,1.1-1.9-1.1-2.3-1.8-2.1-4.2,2.1,1.4,3.4,2.6,6.3,2.1-.5-2.8-4.3-1.3-5.4-2.7-1.5-2.1-.8-7.3-.9-9.9,2.2.9,2.8,4.1,4.7,5.4,2.8,1.8,16.3-4.3,15.3-9.6,4.9-4.1,8-10.8,12.6-15.3-4,2.3-7.3,5-11.5,6.8v-1.1c1.2-.3,7.3-4.3,7.4-6.3-10.2,3.8-14.2,2-17.3-8.4-.8,0-.7,7.1-.5,8.4-3.2-6.2-1.9-13.6-.8-20.2s7.2-23.6,11.3-31.3c2.2-4.1,6.5-10.1,9.5-13.7,14.9-17.6,35.1-28.9,52.6-43.1-10,7.5-22,18.8-32,27.4s-17.8,14.9-22.6,25.2c1.5,1.5,9.9-10.1,13.7-8.4-2.3,2.9-4.3,5.9-6.3,8.9,1,.5,2.9-1,3.6-1.6,7.6-5.7,15.6-13.8,23.2-19.9,57.9-46.9,129.5-96.1,156.1-168.7,16.3-44.5,13-98.7-17.9-136.1,1,5.6,5.2,9.9,7.5,15.1,8.3,18.7,14.7,50.4,12.5,70.7-.5,4.8-2.6,10.6-3.2,16.2-2.8-.6-2.1,1.4-2.6,3.1-21.4,74.3-72.2,123.7-131.9,168.2,51.8-42.3,110.1-97.4,127.2-164,0,0,.8-.2,1.1-1.1s-.2-2.2,0-3.2.7-.4,1.1-2.1-.1-1.4,0-2.1.8-1.3,1.1-3.2-.2-3.6,0-5.3.9-.9,1.1-3.2,0-3.5,0-5.3c1.8-5.6,1.8-14.2,0-20,0-2.1.2-4.2,0-6.3s-1-1-1.1-1.1c-.2-1.7.2-3.6,0-5.3s-1-2-1.1-2.1c-.2-1,.2-2.2,0-3.2-.3-1.7-1-2-1.1-2.1-.2-.9,0-2.1,0-3.2s0-1.8-1.1-2.1c-3-15.8-12.4-31.6-22.1-44.1,1.5-1.6-1.2-2.2-2.1-3.2s-.7-.7-1.1-1.1c-.1-2.5-1.7-4.1-4.2-4.2-.4-.3-.7-.8-1.1-1.1-12.5-19.8-37.5-29.5-60.4-30.5-14.1-.6-29.4,2.8-43.7,3.2,0-.4,1.1-1,1.1-1.1,20.2-6,41.4-7.7,62.5-6.3,8.7.6,16.7,2.5,24.7,5.2,2.3-1.7-21.6-10.2-23.4-10.8-28.1-8.4-52.9-6.1-80.7,1.3s-1.7.9-2.1,1.1-.7,0-1.1,0c-18.2,5.4-32.2,10.9-47.6,22.3-10.7,7.9-19.5,17.7-25.9,29.3-.4-6.8,3.6-18.8,6.3-25.2,4.2-9.9,10.1-15.6,16.8-23.7-2.7-1.9-5.1,1.2-7.3,2.2s-2.5.2-3.2.5c-.8,0-1.8-1-2.1-1.1,55.9-32.6,126.5-57,189.9-30.7,111.5,46.2,98.2,196.3,41.3,280.8ZM1078.6,688.8c.1-8.3-3.6-16.7-6.9-24.1-15.6-35.7-45-62.5-82.7-72.8-15.1-4.1-29.4-5.1-44.9-6v3.1c16.2,1.1,32.1,5.9,47.3,11.6.3,1.8-3.9,1.3-4.8,1.1-2.3-.4-3.6-1.8-5.3-2.1-8-1.4-17-1.5-25.2-1.1s-3.9-.8-3.7,1c41.9-1.1,77.2,20.9,102.4,52.7l23.7,36.7ZM870.5,601.5c-18.9,4.2-34.4,18.4-45.8,33.5-.7.9-2.5,1.4-3,2.2-1.3,2.1-.2,5.9-.5,8.4l23.5-15.9,20.7-9.8c2.2-2.1.7-1.8-1.1-1.1-3.4,1.4-6.5,2.8-10.4,1.1,3.9-2.4,7.6-5.3,11.5-7.4,7.1-3.8,26.3-10.4,4.2-7.9l1-3.1ZM1039.7,653c-3.5-19.7-20.8-30.7-38.9-35.7l38.9,35.7ZM1034.5,673c-2.3-11.4-9.6-20.4-19.2-26.5l-13.3-6.1,32.6,32.6ZM1073.3,683.5c0,0-2.2-.4-2.1.5,2,8,3.7,16.3,5,24.5,4.3,28.9,7,58-2.8,85.9-19.9,56.3-64.8,108.5-108.3,148.2-6.2,5.7-14,11-20,16.8-1.3,1.3-3.4,2.6-3.1,4.7l19.9-13.2c52.9-39.3,103.1-96.6,118.4-162.3,6.4-27.8,11.4-65-.4-91.3s-5.9-13.3-6.4-13.9ZM972.4,946.3l-73.6,52c-11,11.2-23.6,21.7-29.4,36.8,6.4-3,10.6-9.1,15.7-13.7,25.5-23,58.6-44.5,81.9-67.4.8-.8,6.1-7,5.4-7.8ZM940.9,964.2c-1.1-1.1-4.2,2.1-3.1,3.1s4.2-2.1,3.1-3.1ZM935.6,968.4l-8.4,5.8c2.1-.2,4.5-2,6.3-3.2s2.7.3,2.1-2.6ZM859.4,998.9v1.1c.7-.4.7-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M805.3,556.3c-.3,0-.7,0-1.1,0-.7,0-2.5-1.6-3.1-1.1s-1.4,3.9-3.2,6.3c-2.2-.3-2.4-.1-2.1,2.1-1.1.4-1.8.9-3.2,1.1s-.3-1.1-.9-1v2c-1.6.4-1.1-1.4-2.2-2.1,0-.7,0-1.4,0-2.1s-.2-1.9,0-2.1.6,1,2.1-2.1.9-.7,1.1-1.1c1.1-.1,1.7-.1,2.1,1.1s-.7,2.9.5,3.1c1.9-1.1,2.2-4.9,3.7-5.8s3.6-.2,4.1-.6,1.7-5.5,3.3-8.3c1.1-1.9,3.2-4.4,4.2-6.3,0,6.2-5.5,10.7-5.3,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M809.5,553.2c-12,31.8-21.4,59.6-29.4,92.5-9.2,37.7-14.6,67-13.7,106.2.6,23.9,1.9,44.4,6.3,68.3-1.9,1-1,3.8-.8,5.5,1.7,11.4,3.8,23.2,6,34.5-2.8.7-2.9-3.7-3.4-5.5-12.2-40.1-18.8-80.5-19.7-122.2,0-4.4,0-8.8,0-13.1-3,1.4-1.9,6.4-6.3,6.3,2.4-29.9,7.3-61.2,12.9-90.6,2.2-11.6,5.2-22.8,9.1-33.1,2.3-5.8,5.8-11.3,5.3-18.1-.4-.4-9.4,2.2-10.5,2.7-2.5,1.2-13.1,22-15,26-17.6,38.8-21,65.6-26.2,107.3-2.2,17.7-8.1,34.9-4.1,53.2l6.3-3.1c3.1,22.1,6.1,44.2,11.2,66,11.4,48.4,41.1,104.7,29.3,154.7-1.4,6.1-4.6,14.3-8.9,18.9-8.4-31.9-20-62.9-28.9-94.6-26.4-94.3-38.5-192.2-12.8-288.2,2.4-8.9,6.1-17.6,8.4-26.3s1.7-4-.3-5c0,0,.9-1.8,1.1-2.1,3.2-1.5,5.7.6,9.6-.4s2.7-4.2,4.7-4.6,4.1,1.5,7.8.4,4.6-6.3,5.3-6.8,9.8,3.1,14.1-1.1,1.4-4,2.6-4.8,3.6,1,5.6.5,6.6-5,9.2-6.2c.4,2.4,1.1,4.5.2,6.9-4,11.4-13.4,29-14.7,41.2s1,6.5.9,10.2c-.2,5.3-2.7,10.8-3.2,15.7s-.3,8.9,0,11.6-.4,1.7,2.1,1.6c-1.8-8.9,3.9-13.6,6.8-20s23.6-79.9,27.8-79.9-.2,1.2,1,1.1c.2-.6-.2-1.8,0-2.1.7-.9,3.2-2.2,4.2-3.2ZM776.4,581.5v1.1c.7-.4.7-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M978.7,640.4c9.4,4.3,18.2,9.3,26.3,15.8s.7.7,1.1,1.1c1.6,1.3,2.8,2.8,4.2,4.2s.7.7,1.1,1.1c-.4,2.2,1.6,2.5,2.1,3.2,9.7,12.6,19.1,28.4,22.1,44.1.2.9,0,1.8,1.1,2.1,0,1-.2,2.2,0,3.2l1.1,2.1c.2,1-.2,2.2,0,3.2l1.1,2.1c.2,1.6-.2,3.6,0,5.3l1.1,1.1c.2,2.1,0,4.2,0,6.3.3,6.4.2,13.6,0,20s.1,3.5,0,5.3l-1.1,3.2c-.2,1.7.2,3.6,0,5.3l-1.1,3.2c-.1.7.1,1.5,0,2.1l-1.1,2.1c-.2.9.2,2.3,0,3.2l-1.1,1.1c-17.1,66.6-75.4,121.7-127.2,164-17.4,14.2-37.7,25.5-52.6,43.1-.8-5.6-.8-7.2,5.3-6.3.5-1.4-1.5-4.6-1-5.2s8-2.8,8.4-3.2c3.5-3.6-6.6-.4-7.6,0s-1.6,1.9-1.9,2c-3.7-1.7-6.6,1.9-7.4,2.1-3.5,1.1-9.9-1.6-11.9-1s-1.3,4.5-1.7,5.2-1.6,0-2.1.6c-2.2,2.9-2.5,7.6-1.1,11-.8,2.1-1.4,4.1-2.1,6.3s-1.5,3.8-2.1,6.3.1,1.5,0,2.1,0,1,0,1.1c-.4,2.1-.7,4.2-1.1,6.3-4.1,22.4-4.6,38.7-6.3,61-2.8,0-2.9-1.2-3.2-3.6-.5-4.6,0-11.5,0-16.3s0-1.4,0-2.1c0-1.6,0-3.8,0-4.2.2-2.4.9-4.3,1.1-6.3,1.1-11.5,7.8-40.3,6.3-49.4,1.2-1.7,2.5-4.4,3.2-6.3s.1-.2,0-1.1,0-1.4,0-2.1c.3-.2,1.4.4,1.9-.2.8-.8.9-4.7,1.3-6.1s2.4-2,1.6-3.2c-7.9-2.4-13.6-7.2-18.4-13.7.9-1.9-.8-4.9,4.2-4.2,7.9,10.9,22.6,14.9,35.5,11.9,18.6-4.3,59.9-39,74.8-52.9l.5,1c1.9.4,1.7-.3,1.6-2.1,38.6-37.4,96.5-95.3,98.8-152.4,4.3.5,1.1-2.3,1.1-3.2-.5-7.9-.5-19.4,0-27.3,0-.9,3.2-3.7-1.1-3.2-.7-11.8-4.7-22.4-7.4-33.6-1.4-5.7-2.7-3.7-3.2-4.2-3.5-4.3-5.9-10.7-9.2-15.5-8.2-11.7-23.8-25.1-37-30.8.6-2.2.4-4.8,3.2-4.2ZM870,969.4v1.1c.7-.4.7-.7,0-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1005,656.2c-8.1-6.5-16.9-11.5-26.3-15.8-11.9-5.5-19.4-7.8-32.6-9.5s-1.7-.9-3.6-1.1c-3.3-.3-9.6-.5-12.2,1.1-2.1,0-4.3-.2-6.3,0l-3.2,1.1c-1,.1-2.2-.2-3.2,0l-2.1,1.1c-30.5,6.3-57.7,21.9-78.3,45.2-8.1,9.2-23.1,36.6-33.9,38.7s-5,.4-6.6-1.9c5,.4,9.1-1.1,13-4.4s8.8-10.2,9.1-11.9c.8-4.1-6.3,2.6-8.4,3.2-8.1,2.2-9.6-3.2-10.5-10,11.2,1.6,13-1.2,20.5-7.4s3.7-3.7,6.1-6c4.6-4.4,11.4-9,13.3-15,3.2-2.5,6.9-5.3,9.5-8.4,3.9-.1,17.5-11.1,22.1-13.7,5.2-3,23.3-9.1,25.2-10.5,2.2.3,2.4.1,2.1-2.1.7,0,1.4,0,2.1,0,14.2-.4,29.5-3.8,43.7-3.2,22.9,1,47.9,10.8,60.4,30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M712.8,374.5c.3,0,.7,0,1.1,0,.9,1.7,3.6.9,5.3,1.1,29.5,2,75.5,17,102,30.5,4.1,4.8,9.8,7.9,14.7,11.6,3.5,6.6,8.4,11.9,8.4,20l-7.9-11.6c-2.2.2-.9,1.2-3.7,2.1-17.5-21-74.9-37.6-102-43.1-.6-.1-1.5.1-2.1,0h-1.1c-.3,0-.7,0-1.1,0-1.5-1.3-4.4-1.9-6.3-2.1-2.3-1.9-5.9-1.3-8.6-2.2s-1.6-2.4-5.9-2.8c-6.7-.6-12.3-2.6-19.7-3.4-2.3-.2-4.6.2-6.8,0s-.7,0-1.1,0c-3.5-2-8.6-1.7-12.6-2.1s-.7,0-1.1,0c-3.5-2-8.6-1.7-12.6-2.1s-.7,0-1.1,0l1.1-1.1c20.3,1.7,40.6,4.2,61,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M806.4,633.1c3.6-.5,1.6,1.3,1.6,3.2-.2,6.1-2,5.3-3.6,10-1.2,3.5-1,7.4-2.1,11,4.1-3.2,5.8-12.3,9.4-15.3s2,1.9,3.2,2.6c-2.7,6.4-6.8,18.5-6.3,25.2s0,2.1,0,3.1l4.2-2.1c2.8,12.8,21.7-2.9,27.3-7.4-2,6-8.8,10.7-13.3,15s-2.6,3.1-6.1,6c-7.5,6.2-9.3,9-20.5,7.4.9,6.8,2.5,12.2,10.5,10,2.1-.6,9.2-7.3,8.4-3.2s-7.5,10.5-9.1,11.9c-3.8,3.2-7.9,4.7-13,4.4-.7,0-1.7.2-2.1,0-.3-3,.2-1.8,2.1-2.1,6-1,10.3-1.5,13.7-7.3-3.5.5-6.4,1.8-9.8-.2s-2.3-4.6-3.8-3,3.5,6-1.1,5.2c-8.2-22.7.9-53.2,10.5-74.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M851.6,429.1c5.3,7.2,9.6,12.4,8.3,22.5-1,8.4-11,24-17.8,29l-.5-1-1.6,1c-.4-2.4-1.5-7.4-4.5-6.1-9.2,5.1-17.7,11.2-27,16.1s-15.3,6.8-23.1,10c-.5-.8-4.5-1.1-5.3-1.1,15.1-5.8,28.4-12.6,42-21,17.8-11,40-25.3,27.3-49.4h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M781.1,645.7c3.5-13.5,9-26.5,12.6-39.9l3.7,10.5,8.9,7.4-7.9,2.1c-2-.4-.6-8-3.7-8.4l-11.8,45.5c.1,1.3-1.7,2.4-1.8,2.9-1.3,3.6-3,5.9-3.9,10.3-3.7,17.9-4.1,37.2-6.7,55.3l3.2,1.7c.2-3-.3-6.1,0-9s1.1-2.3,1.1-2.5c.3,2.4-.9,7.6,1,9,3.7,2.8,3.3-3,5.7-5.5s7.9-5.7,8.3-5.9c1.9-.8,10.2-1.5,7.1,1.3s-8.3,2.7-10.9,4.4c-11.5,7.8-10.6,15.4-16.5,25.1v-3.2c0-1.4,0-2.8,0-4.2s0-2.8,0-4.2c-.4-30.3,3.8-62.8,11.6-92.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M809.5,624.6c-1.1,1.1-.6,3.3-1.1,4.2s-1.4,2.6-2.1,4.2c-9.6,21.4-18.7,51.9-10.5,74.6.5,1.4.3,3.7,1.1,5.3-1.9.3-2.4-.9-2.1,2.1-4.1-1.6-5.8-11.9-6.4-12.5s-2.3.1-3-.1c-.7-2.1,1.9-2,2.1-2.8.7-3.1.5-8.9,1.1-12.9,2.1-15.4,4.8-29.2,8.4-44.1s1.2-6.2,2.1-8.4,5.3-9,8.4-10.1c1.3-.5,2,.7,2.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M829.5,496.4c-.5,7.8-6,14.6-9.3,21.7s-6.1,14.7-9.6,21.4c-1,1.9-3.1,4.4-4.2,6.3,1.6-3.2-2.3-4.3-2-5.6.7-2.6,3.5-6.2,4.6-9.1,3-8.2,5.5-15.6,8.8-23.8s2.4-3.5.2-4.6c3.7-1.8,7.9-4.3,11.6-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M769.6,738.2c-1.6.4-1.6,3.9,0,4.2,0,1.4,0,2.8,0,4.2l-1,.5,1,.5v2.1c-.8,1.3-1.5,2.4-3.2,2.1-.9-39.2,4.4-68.4,13.7-106.2h1.1c-7.7,29.7-11.9,62.2-11.6,92.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M816.9,965.2c.5,3.6-1.2,8.7,1.1,11.6,0,1,.1,2.1,0,3.2s-2.4,2.4,0,3.2c0,2.4,0,4.9,0,7.4-3.1-.6-2.2,1.7-2.1,3.7,0,3.2,1.1,6.1,1.1,8.5,0,3.8-1.9,7.9-1.1,12l-5.2-1c0-4.9,0-9.8,0-14.7,4.7,1.4,4.9-5.5,0-4.2,0-1.4-.1-2.8,0-4.2s3.2-3.7-1.1-3.2c0-.7,0-1.4,0-2.1.7-6.7,3-7.3,4.4-10.9s1-7.5,1.9-11.2c.3.7.8,1.4,1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M809.5,553.2c-1,.9-3.5,2.3-4.2,3.2-.3-6.1,5.3-10.6,5.3-16.8,3.5-6.7,6.4-14.5,9.6-21.4s8.8-13.9,9.3-21.7c1.8-1,4-3.5,6.3-3.7-9.4,19.8-18.5,39.9-26.3,60.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M805.3,556.3c-.2.3.2,1.5,0,2.1-1.2.2-1-1.1-1-1.1v-1.1c.3,0,.7,0,1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M813.7,499.6c-.8,2.1-.9,4.2-3.2,5.3-14.4,6.4-26.2,11.4-42,14.7s-3.3.9-4.2,1.1-1.4-.1-2.1,0c-2.5.4-5.5,1.9-7.4,0,18.4-4.8,35.3-11.2,52.6-18.9,1.5-.7,4.3-1.1,6.3-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M774.8,721.3c0,.2-1,1.2-1.1,2.5-.3,3,.3,6.1,0,9l-3.2-1.7c2.6-18.1,3-37.4,6.7-55.3.9-4.4,2.6-6.7,3.9-10.3-2.8,18.5-4.4,37.1-6.3,55.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M833.7,977.8c-3.3,3.6-11.1-7-12.6-5.3-.9,3.5,1.2,5.7,2.1,8.4l-5.3-1.1c.1-1,0-2.1,0-3.2.2-4.2.5-7.7-1.1-11.6s-.8-1.4-1.1-2.1c.2-1,.7-1.4,1.1-2.1,4.8,6.5,10.6,11.3,18.4,13.7.8,1.1-1.3,2-1.6,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M851.6,429.1h-4.2c-2.7-5.7-7.2-8.4-11.6-11.6s-10.7-6.8-14.7-11.6c13.6,6.9,21.1,10.6,30.5,23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M829.5,490.1c-5.1,3.4-10.2,6.8-15.8,9.5s-4.8,1.4-6.3,2.1l3.2-3.1h-3.2c6.1-2.5,14.1-6.4,20-9.5l2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M788.5,686.7c-.6,4-.4,9.9-1.1,12.9s-2.8.7-2.1,2.8c-1.5-.5-1.4-11.1-1.1-13.1.5-2.7,1.9-2.8,4.2-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M819,622.5c.3,0,1.3,1.1,2.1,1.1-1.3.5-2.6,2.5-5,3s-4.6-1.6-7.6,2.3c.4-.9,0-3.1,1.1-4.2,3.5-1,3.9-2.8,9.5-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M787.4,710.8c2.3,2.4-5.5,5.6-7.3,6.3-2.1-4.2,6-7.7,7.3-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M842.1,480.6c-.6.4-1.5.6-2.1,1.1,0-.3,0-.7,0-1.1l1.6-1,.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M837.9,483.8c-3.4,3.1-4.7,3.8-8.4,6.3l-2.1-1.1c2.1-1.1,9.7-4.7,10.5-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M840,481.7c-.2,3.5-1.6,1.6-2.1,2.1.2-.1-.4-.5,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.2,630.9c-5.2.1-10.5-.2-15.8,0,2.7-1.6,8.9-1.5,12.2-1.1s3.1,1.1,3.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M798,634.1c-.6,1.1-3.1,4.5-3.2,5.3h-1.1l1.1-6.3c.9.3,2.3,0,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M799,634.1c-.9,2.2-1.5,5.9-2.1,8.4-.8-.6-2.2-2.3-2.1-3.2s2.6-4.2,3.2-5.3h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M794.8,633.1l-1.1,6.3c-2.4-1.8-1.3-4.9-1-7.4,1.4-.5,1.9,1,2.1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M719.1,375.5c-1.7-.1-4.4.7-5.3-1.1,1.9,0,3.7-.5,5.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M924.1,630.9c-.2,0-1.3.8-3.2,1.1l3.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M917.8,632c-.1,0-.5.7-2.1,1.1l2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.6,1148.1c20.8,9,54.6,23.5,76.7,25.2.5,1.4,2,1,3.2,1.1s.7,0,1.1,0c4,4.4,17.7,4.2,20.8,6.6,1,.8,3.1,7.7,4.3,9.9,4.7,8.3,15.6,23.7,24.9,26.6,3.4,1,0-3.9-.3-5-2.1-9.2-3.1-18.6-6.6-27.6,12.6,1.8,25.2,3.2,37.8,4.2,0,3.8-6.2,4.2-6.3,7.9s5.7,11.5,7,12c5.6-.5,11.3,1,16.6,1.3,26.4,1.3,55,1.2,81-2.1,2.8-.4,6.9.6,9.3-.2s8.1-16.5,10.2-19.8c11.6-1.2,23.1-3.2,34.7-4.2-5.8,22.2-24.1,34.6-46.2,37.8l9,1.1,36.2-3.2-6.3,5.2c-19,4.4-38.3,9-57.8,10.5-.2,1.8,2.4,1,3.7,1,4.4.2,9.3.2,13.7,0,8.8-.3,18-.6,26.8-1.1-6.6,1.5-13.8,2.6-20.5,3.1-44,3.8-92.6,3.1-136.5-2.2-11.1-1.4-22.5-3.1-33.2-6.2.7,0,1.4,0,2.1,0,5.9,1,23.1,3.4,28.4,3.2s1.4,0,2.1,0l-1.1-2.1c22.7,5.6,46.6,5.8,70,5.3s5.5-1,8.3-1.1c10.7-.4,21.7,1.2,32.1-2.1,6.3-.4,17.8-.6,23.4-2.2s4-3.3,2.9-4.1c-46.7,0-93.3.7-139.8-3.2-3.2,2.4,7.3,2.3,8.4,2.6s7,1.2,6.3,3.7c-17.1-2.1-36.4-5.2-51.9-11.7-3.5-1.5-10.2-1.4-7.4-5.1,10.2,3.3,21.2,3.1,31.8,5s1.8-1.4,1.3-1.9-8.3-2.3-10.7-3.5c-7.6-3.7-22.3-18.2-25.5-26s-1.4-7.6-2.6-9c-2.7-2.9-15.1-3.6-18.9-4.7-12-3.4-25-7.4-36.8-11.6s-4.3-3.4-6.8-3.2c-2.7,0,5.6,16.6,6.3,17.9,2,3.7,7.6,10.4,8.5,13.6s-.8,5-.6,5.3,5.2.8,5.3,3.2c-3.6,0-6.8-2.2-10.2-2.9s-3.2-.7-2.4,1.4,10.3,8.8,12.6,10c6.1,3.2,16.6,7.9,23.1,10.5l-4.5-.3c-44.6-13.6-77.1-48.2-95.4-90.1,1.8-1.7,15.2,9.9,17.5,11.4,7.3,4.6,13.9,6.4,21.4,9.6ZM593,1228c-1.5-.8-2.8.7-2.1,1,1.5.8,2.8-.7,2.1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M352.3,1216.4c31.3,12.4,65.5,21.7,98.8,26.3-.4,2.7,1.7,2.2,3.3,2.5,27.7,5.6,97.7,8.2,124.5,2.8,1.9-.4,4.2,1.3,3.6-2.1,31.9-2.7,72.3-9.5,102.5-20,6.4-2.2,12.3-6.8,19.4-6.3-5.7,11.7-8.3,8.2-18.3,12.7-7.6,3.5-15.7,8.7-24.2,12.7s-3.3.6-2.7,3c-40.9,12.2-80.4,15.3-123,15.8v-1.1c10.3,0,22.7-1,33-2.3,7.3-.9,17.4-2.3,24.3-4.1s3.3,0,3.7-2.1c-23.1,1.3-46.7,1.7-69.9,1.1-29.2-.8-59.7-2.7-88.8-6.4s-9.3-2.9-16.8-1.1c-2.6-1-6.8-1.5-8.4-2.1s-1.1-1.7-1.8-2.1-6.8-1.3-4.5-3.2,7.3,0,8.9,0,3.9.8,3.7-1c-11.6-3.6-23.7-5.2-35.7-6.3,7.4,6.6,18.8,10.7,28.4,13.7s3.8,2.4,9.5,1.1c3.3,1.3,11.3,2.5,11.6,6.3-32.8-6.5-84-18.5-103-48.4l22.1,10.5ZM603.5,1249h16.8l-10.5,6.3c11.9-1.5,24.4-3.5,34.7-10,.7-2.9-4.2-2.6-5.8-2.7-8.8-.2-23.2,2.8-32.1,4.8s-3.4,0-3.1,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M782.2,1120.8c7.4-1.4-2.8,8.2-4,10.2-8.8,14.2-17.4,31-28.6,43.4-18.2,20.3-51.4,37.8-76.7,47.3-4.8,1.8-9.9,3.6-14.7,5.3-8.8,3-14.9,3.7-24.2,5.3,8.8-5.9,22.9-5.5,31.5-11.6l25.6-11.7c11.9-9.7,21.7-8.7,33.2-19.8,10.3-9.9,28.2-27.9,30.5-42.6.2-1.5,0-2-1.6-1.6-5.3,1.6-14.6,7.9-20.5,10.5-.8.4-2.1,1.1-4,2s-5.7.8-7.3,2.5-4.5,10.6-6,13.4c-6.8,12.1-16.2,28.2-31.7,29.3-6.3.5,1.3-4.9,2.7-6.8,5.3-7,6.1-11.6,9.6-18.8s4.8-5.4,5.1-9.1c-5.6-.6-10.7,2.9-15.8,4.2s-4.6-.4-6.3,0v-1.1c27.8-6.8,84.5-29,103-50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M685.5,1172.3c.8,5.1-4.3,4.4-6.2,6.9-2.9,3.8-8.1,18-11.1,23.6s-1.5,2.6-2.7,3.7c2.4.5,8.9,1.3,9.4,4.3.2.9-8,8.8-9.4,9.9-8.6,6.1-22.7,5.6-31.5,11.6-.3,0-.7,0-1.1,0h-2.1c-6.7.9-12.9,2.7-20,3.2s-18,.8-26.8,1.1c-4.4.2-9.3.1-13.7,0s-3.9.8-3.7-1c19.5-1.5,38.8-6.1,57.8-10.5,6.9-1.6,14-2.6,20.8-5,3.5-1.2,9.4-2.1,9.7-6.6-10.4.7-20.8,3.2-31.1,4.1-1.2.1-3.8,1-3.5-.9,11.6-2.3,19.9-13.7,25.4-23.5s4.5-11.9,6.6-13.4,19.6-4.3,24-5.4,2.6-1.8,2.8-1.8c1.7-.4,4.6.4,6.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M269.2,1107.1c-.4-.3-.7-.7-1.1-1.1.3.4.8.6,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.1,1105c-2.3.1.4,4,1.4,5s1.7.2,1.8.3c.3.3.7.8,1.1,1.1,13.4,17.1,26.4,25.1,46.2,33.6-3.8-.3-1.4.9,0,3.2-7.5-3.2-14.1-5.1-21.4-9.6-2.3-1.5-15.7-13.1-17.5-11.4,18.3,41.9,50.8,76.5,95.4,90.1l4.5.3c13.9,5.6,29.3,10.2,44.1,12.6-.7,0-1.4,0-2.1,0-15.3,0-52.4-11.7-67.3-17.9-7.5-3.1-19.6-9.2-26.3-13.7-28.2-19-50.4-65-63.6-95.7l-1.6-6.3c1.6,2.5,3.5,5.9,5.3,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.2,1106.1c-.4-.3-.8-.6-1.1-1.1,1.3,0,.9.9,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.5,1112.4c-.6-.3-.9-1-1.1-1.1.3.3.7.7,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M280.8,1115.5l-2.1,1.1c-1.6-1.5-2.7-2.7-4.2-4.2,2.1,1.1,3.7,1.5,6.3,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.5,1111.3c-.5-.2-1.7.2-2.1,0-.3-.4-.8-.7-1.1-1.1-.7-1-.6-2.4-1.1-3.2,1.7,1.7,2.4,2.2,4.2,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M809.5,1037.7c.2,19-4.4,38.9-10.5,56.8l-1.1,2.1c-10.4,29.2-26.4,56.2-46.2,79.9-.4-1.2-1-1.7-2.1-2.1,11.2-12.5,19.8-29.3,28.6-43.4,1.2-2,11.5-11.6,4-10.2,1.6-1.8,6.1-4.1,1.1-4.2,10.7-9.5,9.2-14.7,12.9-26.5.8-2.5,2.4-4.7,3.2-7.3,4.7-17.3,8.2-35.5,9.2-53.4,2,1.1,1,6.3,1,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M827.4,993.6c1.5,9.1-5.2,37.9-6.3,49.4-2.6-5.4-1.9-11.7-2.1-17.4s1.1-4.2-2.1-3.6l-2.1-4.2c1.7,4.6-2.2,7.5-2.9,10.2s.8,6.1-1.3,8.7v-23.1l5.2,1c-.8-4.1,1.1-8.2,1.1-12s-1.1-5.3-1.1-8.5-.9-4.3,2.1-3.7c0,3.4-.2,5.9.7,9.3s-.3,2.7,2.4,2.3c-.7-5.8.6-10.2,4.2-14.7.5,1.7,1.9,4.8,2.1,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M751.7,1176.5c0,0-1,.6-1.1,1.1-25.2,29.4-40.4,34.3-76.7,45.2l-1.1-1.1c25.4-9.5,58.5-27,76.7-47.3,1.1.4,1.7.9,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M846.3,1001c-4.1,7.7-9.8,22.8-11.3,31.3s-2.5,14,.8,20.2c.6,5.2.7,4.1,4.2,6.3s1.8,1.9,3.2,2.1c-.8.2-1.1,1.2-3.5,1-4.8-.4-5.8-5.3-6.7-9.2l-1.3-11.8c-1.6,8.6-7.4,22.6-1.1,30s4.4,3.5,8.2,1.8,6.2-4.1,6.6-4.5c1,5.2-12.5,11.4-15.3,9.6-1.9-1.2-2.5-4.5-4.7-5.4.1,2.6-.6,7.8.9,9.9s4.8,0,5.4,2.7c-2.9.5-4.2-.7-6.3-2.1s-.8.2-1.1,0c-1.5-23.1,4.4-45.9,12.6-67.3,1.3-3.5,3.9-9.6,5.7-12.7s.7-2.5,3.7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.2,1242.7l1.6,1,.5-1c41.1,5.2,85.9,6.7,127.2,3.2.6,3.4-1.7,1.7-3.6,2.1-26.9,5.4-96.8,2.8-124.5-2.8-1.5-.3-3.6.2-3.3-2.5.7,0,1.4,0,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.5,1249c-.7,3.2,1.6,1.8,3.3,2.4,25.3,9,67.5,11.5,94.4,11.3v1.1c-34.6.4-68.5-2.7-103-9.5-.3-3.8-8.2-5-11.6-6.3,7.5-1.8,9.9.2,16.8,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M659.2,1248c-.5-2.4,1.2-2.3,2.7-3,8.4-4,16.6-9.2,24.2-12.7,10-4.6,12.6-1,18.3-12.7s-.6-1.2.7-2.2c3.3-2.6,13-5.6,17.2-7.8-14.3,21.3-39.3,31.3-63,38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M840,997.8c-1.2,4.7-3.8,9.6-4.8,14.7s-1.6,3.7,1.6,3.2c-8.2,21.4-14.1,44.1-12.6,67.3-1.3-1.1-1.3-1.6-1.1-3.2.2-1.3-.1-2.8,0-4.2,1.7-22.3,2.2-38.6,6.3-61,2.5.5,2.3-1.2,2.9-2.8,1.6-4.4,2.3-12.5,7.6-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M820,1055.6c-.1,4.9-.6,11.7,0,16.3s.4,3.6,3.2,3.6c-.1,1.4.2,2.9,0,4.2-.4,3.1-4.1,5.2,0,10.5-2.8-1.1-2.9-1.4-4.7-4.2-1,0-.3,1.5-.5,2.1-2.9,1-3.2-4.9-3.2-7.4.1-7.9,2.5-17.2,2.1-25.2h3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M353.3,1212.2l-1.1,4.2-22.1-10.5c-1.3-2-4.2-3.2-3.2-7.4,6.7,4.5,18.8,10.5,26.3,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M813.7,1064c.1,4.8-.4,12-1.1,16.8-.5,4.1-2.1,8.4-2.1,12.6-.6.4-2.4,2.7-3.7,3.1-.4-1.6,1.8-4.2-.5-5.2,2.1-7.8,2.9-16.1,5-24s-.6-4,2.4-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M816.9,1022c3.2-.6,2,1.7,2.1,3.6.2,5.7-.5,12,2.1,17.4-.2,2-.9,3.9-1.1,6.3-1.3,1-1.8,3.6,0,4.2,0,.7,0,1.4,0,2.1h-3.2c-.1-2.8-.6-3.3-1.1-5.3-1.9-7.9,2.8-19.4,1.1-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M823.2,1090.3c.3.1.7-.1,1.1,0v1.1c-6,4-16.2,4-21.6,10.5-.1-3.5,2.9-7.6,3.7-10.5,2.3,1,.1,3.6.5,5.2,1.3-.4,3.1-2.8,3.7-3.1,1.4-.8,1.6-.5,3.9-2.1s2.2.6,3.4-3.2-.5-2.1.5-2.1c1.8,2.8,1.9,3.1,4.7,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M816.9,1055.6c.4,8.1-2,17.3-2.1,25.2h-2.1c.6-4.8,1.2-12,1.1-16.8s0-1.4,0-2.1c1.8-.9.8-3.6,1.1-5.3s1.4-4.1,1.1-6.3c.5,1.9.9,2.4,1.1,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M250.3,1037.7c2.7,2.9,1.6,7.5,3.2,11l-2.1.5c-.7-5.5-1.1-5.2-1.1-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M673.9,1222.8c-.9.3-2.9,2-5.3,2.6-3.4,1-6.9,2-10.5,1.6,4.8-1.6,9.9-3.5,14.7-5.3l1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M814.8,1056.7c-.2,1.6.8,4.3-1.1,5.3-.1-1.6-3.5-5.9,1.1-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M832.6,1086.1c.7,3.3-2.7,2.6-5.3,1.1,2,.4,3.5-.4,5.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M632.9,1232.2c-1.7.3-2,0-2.1,0h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M455.3,1242.7l-.5,1-1.6-1c.7,0,1.4,0,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M798,1096.6l1.1-2.1c-.4,1.1-.9,1.7-1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M824.2,1091.4v-1.1c.3.1.8-.2,1,.5,0,.7-.9.4-1,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M750.7,1177.6c0-.4,1.1-1,1.1-1.1-.3.4-.7.7-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M260.8,965.2c-1.3,4.1-2,8.5-3.2,12.6-3.4.4-1.8-1-1.4-2.9s1.6-9.9,4.5-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M256.6,979.9c0,.7,0,1.4,0,2.1-6-1.1-.8-1.6,0-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M289.2,871.7l-1.1,2.1c0-.1-1.7-1.4-1-2.1s1.7.2,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M676,510.1c4.5-2.7,13.6-6.9,8.9-12.5s-34.8-12.6-43.3-14.5l-61.2-9.8c25.8-1.2,51.5-1.7,77.2,1.1s54.2,8.7,61.5,17.3c5.8,6.7-.6,8.6-5.7,11.2s-3.3.4-2.8,3c-11.4,2.1-23.1,4.4-34.7,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M327.1,486.9c16.1,1.4,34.6-8.7,50.4-13.1,13.3-3.7,30-6.7,43.7-8.8s46.9-5.9,48.8-4.3c0,1,0,2.1,0,3.2-15.5-1.4-30.1,3.6-45.2,5.8,0,2.4,1.8,2.5,3.6,2.7,6,.7,11.4-1,16.8-1.1,8.2-.2,16.5.2,24.7,0,.2,3.1,0,5,.7,8.2,1.4,6.4,5.6,11.1,7.7,17-22.4-1.7-46.2-2-68.3,2.1.6-3.2-1.6-2-3.6-2.1-25.8-1.6-55.4-3.9-81,1.1s-2.9,2.5-4.4,2.9c-5.2,1.6-10.6-3.4-15-5.1,5.5-.4-2.4-1.1,1-2.6s4.7-.6,6.9-2.6,1.4-3.1,1.5-3.2c.5-.4,8.2,7.6,10.5,0,.3,0,.7,0,1.1,0ZM394.3,478.5c-2.3-6.9-12.5-2.8-17.9-3.1-.5,5.9,16.8,4.3,17.9,3.1ZM417.5,478.5c0-5.3-9.3-2.3-12.6-1.6-7.6,1.5-19,4.2-26.3,6.3s-9.8,3.4-10.8,3.9-2.1,1.2-1.8,2.9l70.4,2.1c1.7-1.3,0-1.9-1.6-2.1-5.8-.7-29.1-1.1-32.1-5.3-2.8-3.9,14.1-5.7,14.7-6.3ZM440.6,491.2c-1.5-.8-2.8.7-2.1,1,1.5.8,2.8-.7,2.1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.6,474.3c8.2-2.3,5.7,4.2-1,4.2.2-.9-.3-2.5,0-3.1s1-1,1.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346,461.7c.1,3.8-4.5,3.3-7.3,4.2v1c1.3-.3,2.2.8,3.1,1.1h-1.6c-.5.2-.6.5-.5,1.1-2.3-1-8-1.3-10.5-1.1-4,.5-3.5,3.4-4.4,4-1.4.8-3.4.2-7.2,2.3s-.7.7-1.1,1.1-1.4-.5-2.2.6-.8,3.4-1,3.6c-.4.3-8.1-2.4-10.5-1.1.5,2.8,6.3-1.1,5.3,3.1-1.9-.6-4.5,1.2-5.7,1.1s.2-2.6-1.6-2.2c-2.4,10.8-5.5,3.9-12.1,5.2s1.1,3,.5,4.2c-5.7-.5-5.8-1.3-10.5-3.2l13.7-8.4c1.5-.2,3-1.7,4.2-2.1,15-5.4,33.6-12.6,49.4-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M470,463.8c0,2.4-.1,4.9,0,7.4-8.2.2-16.5-.2-24.7,0s-10.9,1.8-16.8,1.1-3.6-.3-3.6-2.7c15.1-2.2,29.7-7.2,45.2-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M339.7,469.1c0,.4,1.4,1.2,1,2.1h-8.4c-.6,1.5,4.3,1,2.1,3.2s-9.3,2.2-8.4-1.5,3.6-2.6,3.1-4.8c2.5-.3,8.2,0,10.5,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326,486.9c-2.4-.3-6.2,1.1-7.4-2.1,4.6.4,7.1.2,8.9-4.2l-.5,6.3c-.3,0-.7,0-1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.3,482.7c-1-1-.6-2.1,1.5-2,4,.2,6.5,0,10.1-2.2.6,4.9-9.6,6-11.6,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M492.6,492.2c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M822.1,478.5c-13.6,8.5-27,15.2-42,21-8,.1-16.9,3.4-25,5-53,10.1-105,18.8-159,22.4-14.1-.9-28.1,2.4-42,0l7.4-2.1c76.8-2.9,160.9-12.9,233.3-38.9,4.6,1.5,14.1-1.3,15.8-6.3.9-.2,1.8-.9,3.2-1.1s4,2.7,6.3-1.6l-2.1-1.6c.7-.4,1.4-.7,2.1-1.1l2.1,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.9,503.8c.3,1,1.2,1,2.1,1.1s1.4,0,2.1,0l4.2,1.1c.3,0,.7,0,1.1,0l3.2,1.1c71.4,16,153,20.7,226,17.9l-7.4,2.1c14,2.4,27.9-.8,42,0-.2,0-1.2,1-2.5,1.1-5.9.4-13-1.2-18.5,1-38.1.4-74.8.2-112.5-1.1l3.1-2.1c-45.5-2.7-91.2-7.5-135.8-17.2-24-5.2-41.7-10.4-63.9-20.7,18.9,5.1,37,13.9,56.8,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M849.5,429.1c12.6,24.1-9.5,38.4-27.3,49.4l-2.1-4.2c15-8.6,36.7-25.4,27.3-45.2h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M783.2,484.8c-1.8.8-3.7,1.4-5.3,2.1-2.4-3.6-6.2-3.5-9.2-5s-5.8-6.1-11.9-4.4c-.2,1.3,2,1.5,3.1,2.1-3.2-1.2-1.4,3-2.7,3.2-1.9.4-4.7-.4-6.8,0,7.5-1.4,4.5-.9,4.2-4.2s1.3-2.3.5-3.1c-.6.7-1.8,1-2.6,1,0-2.7-2.4-3.8-4.7-4.2l-.6,1c-.4-.4-1.5-.6-2.1-1.1.1-1,0-2.1,0-3.2.9.3,2.7,0,4.2.5,11.7,4.1,23.4,8.2,33.6,15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M778,486.9c-.3.1-.6.8-1.1,1.1h-1.1c-.6-.1-1.9.2-2.1,0s.3-1.4-.2-1.9c-1.3-1.1-8.5.2-8.7,2.9-6-4.8.4-3.3.5-7.3-2-.2-3.6-1.3-5.3-2.1s-3.3-.8-3.1-2.1c6-1.6,7.9,2.5,11.9,4.4s6.8,1.4,9.2,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M832.6,428.1c2.8-.9,1.4-1.9,3.7-2.1l7.9,11.6c0,2.8-1,7-2.1,9.5-1.8-7.8-4.5-12.9-9.5-18.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M810.6,479.6c-1.6,5-11.2,7.8-15.8,6.3,5.4-1.9,10-5.1,15.8-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M817.9,475.4l2.1,1.6c-2.3,4.3-5.1,1.4-6.3,1.6-.8-3.1,2.5-2.3,4.2-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.3,505.9l-4.2-1.1c2.2.3,2.9.8,4.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M335.5,506.9l-3.2-1.1c1.4.3,2.8,1,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M325,504.8c-.9,0-1.8,0-2.1-1.1.9,0,1.8,0,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M775.9,488h1.1c-.2.1-.2.6-.5.7l-.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M747.5,482.7c-.2,0-.2-1.6-2.1-1.1.3-.1-.4-2.5,4.2-3.2l-2.1,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M745.4,481.7c-1.2,1.3,3,6.8-.5,6.3-2.1-4.9-2.9-1.8-7.4-2s-8.9-1.6-10-6.4l2.1-3.2c-.5,9,9.9,8.7,15.8,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M727.5,476.4c-.1.5,0,1.5,0,2.1-6.8.3-12.1,4-15.8-3.2,3.9,3.2,11.2,1.7,15.8,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M711.8,475.4c-.4-.7-.8-1-1.1-2.1h1.1c.1.6-.2,2,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M754.9,478.5c.3,3.3,3.2,2.8-4.2,4.2-1.8.3-1.4.6-3.2,0l2.1-4.2c1.7-.2,3.6.2,5.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.2,460.7l1.1-1.1c-.3,0-.7,1-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347,461.7c.1-.5.6-1,1.1-1.1-.2.5-.5.9-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M679.2,374.5c2.2.2,4.5-.2,6.8,0,7.4.8,12.9,2.7,19.7,3.4s4.7,2.4,5.9,2.8c2.7.9,6.3.3,8.6,2.2-.7,0-1.5.1-2.1,0-1-.2-2.4.3-3.6,0l-35.3-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M651.9,369.2l-1.1,1.1c-3.7-.4-8.3-.3-11.6-2.1,3.8.2,8.7.7,12.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M678.1,374.5c-4-.3-9.1-.2-12.6-2.1,4,.4,9.1.1,12.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M664.5,372.4c-4-.4-9.1-.1-12.6-2.1,4,.4,9.2,0,12.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M720.2,382.9c2,.2,4.8.8,6.3,2.1-2.8-.3-6.1-.1-8.4-2.1.7.1,1.4,0,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M727.5,385h1.1c0,0-.2.1-1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M700.2,465.9c-.6.3-1,1-2.1,1.1l2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M719.1,467c-.3,0-.7,0-1.1,0l.5-1,.5,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M691.8,595.2c2.1,1.3,4.3,3.9,4.2,6.3-3.1,0-3.4,2.6-4.2,4.7-3.7,9.2-7.2,22.3-10,32.1-21.3,75.2-26.4,157.2-17.2,234.8,4.8,40.6,14.7,80.6,23,120.5,0,.6,0,1.5,0,2.1s0,1.8,1.1,2.1c-.3,3,2.5,20.6,3.2,25.2-1.9-.9-2.9-.8-4.9-.3-19.5,5.3-38.8,14.2-59.2,15-4.9-43-12.4-84.7-15.8-127.7-2.8-35.9-3.4-71.7-3.2-107.7-54.7-5.9-111.3-15.1-160.3-41-1.7,0,1.4,17.6,1.6,19.5,5.7,72,.5,133.7-5.2,205-1.8,21.9-3.5,43.8-4.2,65.7,62.6,5.9,125.8,0,187.1-12.6.4,3.2,3.3,11.5.3,12.4-44.2,6.3-88.6,10.4-133.3,11.8-21.9.7-43.2.9-65.1-2.2-9.7-1.4-44.5-7.6-51.7-11.4s-2.8-2-2.5-5.4l-5.3,2.1c5.8-66,21.2-130.8,26.3-197.1,5.2-67.5,1.5-137.9-10.5-204.4,29.3,13.6,55.6,33.3,85.9,44.9,13.9,5.3,28.2,9.3,43,11.7,3.5.6,15.6.8,17.2,1.7s-3.4,7-3.8,8.9l-18.3,26.4c14.9,2.1,30.5,1.9,45.4-.3,20.2-2.9,39.4-10.9,59.2-15.4,1.8-18.1,4.1-36.1,6.9-54,3.6-22.4,9.2-44.5,12.4-66.9,11.3-1.2,23.9-4.5,35.4-5.3,2-.1.8,2.2,2.9,2.2s5.6-.8,7.9-1.2c0,.7,0,1.4,0,2.1,4.5.5,8-.2,10.5-4.2.3.1.8-.2,1.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M389.1,599.4c4.4-.7,5.7,6.2,9.5,8.9,5.8,4.1,18,3.9,23.7-.5s1.3-3.1,2.1-3.2c3.3-.5,5.9,6.1,11.6,6.3s8.4-4.1,10.4-4.2,2.2,5.4,7.4,6.3,7.2.2,11-3.1,1.5-.6,2.1-1.1c1.9,8.4,15,6.2,18.9,0,3.9,10.6,19.1,6.7,13.7-5.2,1.4,0,2.8,0,4.2,0-.1,1,.2,2.2,0,3.2s-1.4,1.7-.9,3.4c1.3,4.8,11.9,6.3,11.4-.3,3.6-.6,5.1,3.5,8.1,4,4.6.8,5.1-3.8,6.1-4,1.9-.5,3,4.1,7.1,3,1.9-.5,3.9-4,2.9-5.1s-9.7,1.2-3.2-3.2c3.1,0,6.3,0,9.5,0,1.2,4.7-2.8,2.7-3.2,3.2-2.3,3,6.3,6.5,8.9,6.3s4.2-2.7,5.9-3.2,1.7-.1,2.1,0c1.4.4,3,2.6,5,3,5.1,1.1,9.9-6,2.4-7.2l2.1-2.1c1.1,0,2.1,0,3.2,0-.6,1.9,1.5,3,3.2,3.2-2.4,6.2,5.7,6.8,9.5,3.2.1.1,2.4.4,2.8,2.2,1.3.2,2.3-1.1,2.4-1.1,2.6,0,5,1.8,7.4-.5s-.8-4.1-1.1-4.7,0-.7,0-1.1c2.5,0,3.6.7,3.2-2.1.7,0,1.4,0,2.1,0l.7.9c.8.2,1.2-.9,1.4-.9,3.3-.8,6.2-.9,9.5-1.1s2,.2,4.2,0c5.8-.5,12-.4,17.9-1.1-3.3,22.4-8.8,44.5-12.4,66.9-2.9,17.9-5.1,36-6.9,54-19.8,4.5-39.1,12.5-59.2,15.4-15,2.1-30.5,2.4-45.4.3l18.3-26.4c.4-1.9,6-7.6,3.8-8.9s-13.8-1.1-17.2-1.7c-14.7-2.4-29.1-6.4-43-11.7-30.4-11.6-56.6-31.4-85.9-44.9-1-5.3-9.9-40.5-8.3-42,1.8.4,2.9-.7,4.1-1.1s6-1.9,7.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M383.8,1096.6c1.4,0,2.8,0,4.2,0,7.6,0,20.7-.9,27.6-3.4s3.1-.4,2.9-1.8c-11.7.5-23.2-.4-34.7-2.1-1-.1-1.8-1-2.1-1.1l-4.2-25.2c12.6,1.4,24.9,4.6,37.4,6.2,61.8,7.5,131.9,3.5,193-7.5,15.4-2.8,23-6,39.2-6,6.6,0,27.8-2.2,29.9,6,1,3.9-8.9,15.3-11.9,18.2-46.8,45.2-175.1,50.6-237.6,48.4-8.6-.3-22.3-.7-30.4-2.2-7.1-1.3-12-22.9-13.2-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M691.8,1023c.3,2.4,1.7,4.6,2,6.9,2.2,18.3,3.3,36.9-.4,55.1l-46.8,18.9c12.3-.7,34-5,45.4-1,12,4.3,19.1,2.1,31.8,3.1s3.5-.6,2.6,1.6-22.4,15.5-26,17.1c-4.4,1.9-29.5,10.4-32.6,10.5-13.5.7-27.1,1.5-40.7,2.4s-6,.7-7.9,2.1c-10.3,0-21.5.6-32.1,0-12.8-.7-25.5-3.1-38.3-3.2l21.5-2.1c15.8,4.3,32.3-3.6,46.5-4.1,8.5-.3,10.9,5.1,11.9-8.5-10.7.4-21.4-.5-32.1,0-34.5,1.4-68.5,9.4-103,11.6-24,1.5-45.6-.3-69.3-1.1-5.4-.2-10.9.2-16.3,0-.5,3.2.8,1.7,2.6,2.1,15.6,4,27.9,5.4,44.3,4.1l11,2.1h-16.8v2.1c3,.2,6.1-.3,9,0s2.3,1.1,2.5,1.1h-95.7c2,0,9.7.1,10.5-1.1s.2-3,0-3.1c-1-1-17.5-.6-20.5-2.1l-23.6,2.1c-1.6-.8-3.7-2-5.2-2.7s-4.1-.3-4.2-.5c-2.6-2.6,2.5-3.2,2.8-3.4.7-.5.8-1.9,1.4-2.3,1.2-.8,18.5.2,21.5.5,13.1,1.2,26.2,4.8,39.4,5.2.3-1.6-2-1.3-3.1-1.6-10.6-2.4-24.6-4.8-34.6-8.5-9.8-3.6-25.9-12.9-32.7-20.9s-9.4-12.8-9.9-14.2c-1-2.4-.5-4.8-.6-7.3,14.4,4.3,28,8.8,43.1,10.5-.8,4.4-4.8,2.7-5.3,7.9-1.5,13.5,21.6,26.2,33.2,26.9,1.3,0,2.2,0,1.6-1.6-1.1-2.8-6.3-9-8.1-12.9-2.6-5.5-5.3-13.1-5.5-19.2,5.6.3,14,1.1,18.9,1.1,1.1,6.5,6.1,28.1,13.2,29.4,8.1,1.5,21.8,1.9,30.4,2.2,62.6,2.3,190.9-3.2,237.6-48.4,3-2.9,12.9-14.3,11.9-18.2-2.1-8.2-23.3-5.9-29.9-6-16.1,0-23.7,3.2-39.2,6-61.1,11.1-131.2,15.1-193,7.5-12.6-1.5-24.9-4.8-37.4-6.2l4.2,25.2c-14.7-2.5-29.4-6.5-43.4-10.7s-13-6.7-19.7-8.8c-.9-14.7,1.5-29,3.2-43.5,11.8,17.4,26.6,31.2,44.7,42,2.1.3,1.4,0,1.6-1.5.8-5.7,1.6-13.7,2.1-19.5l5.3-2.1c-.2,3.4-.2,3.9,2.5,5.4,7.2,3.8,42,10,51.7,11.4,21.9,3.1,43.2,2.9,65.1,2.2,44.7-1.4,89-5.4,133.3-11.8,2.9-.9,0-9.2-.3-12.4s0-.7,0-1.1c20.4-.8,39.8-9.7,59.2-15s3-.6,4.9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.4,1009.4c-1.6.4-1.7-.4-2.6-1-6.2-4.3-11.7-9.7-18.5-14.1s-7.4-1.9-6.2-6.3c15.6-54.1,32.5-108.1,39.8-164.2l6.4-65.5,3.2,34.1c2.6,73.2-8.1,145.6-22.1,217.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M328.1,576.3c3.1-.6,10.1,2.3,6.3,5.8-1.7,1.1-7.7-2-7.4-4.8.3-.3.8-.7,1.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M328.1,566.8c-.6,3.7,2.7,1.3,5,2.4s.2,1.6,1,1.7c3.6.9,6.5-.8,8.7-1s1.4,0,2.1,0c.3,1,1.2,1,2.1,1.1s.7,0,1.1,0c-.7,3.1,1.6,2,4.2,2.1s3.5,0,5.3,0c6.1,1.8,12.4,3.4,18.9,3.2.3,0,.7,0,1.1,0l10.5,3.2c2.7.8,4.5,1.8,7.4,2.1v2.1c-3.4-.4-5-.3-8.4-2.1-.5.4,2.7,2.7,3,3.9s-.9,2.2-.9,2.4c-.5-3.4-2-2.5-3.2-3.2-3.5-2-4.9-2.8-9.5-2.1-.6,2,2.4,3.1,2.1,4.7s-8,4.2-8.4,3.7c-1.1-6.1,2.3-10.2,8.4-10.5-2.1-5.3-8.5,0-9.8-.1s-1.9-2.6-3.9-1.9c1.5,2.2,4.7,2.9,4.2,6.3-.9,1-10.6-8.8-13.2-4.2s.6,2.3.4,3.5c-.9,3.8-8.8,3-7.2-1.3,1.3-.8,2.5-1.4,2.1-3.2,1-.3,2.3-1.9,3.2-2.1,1.4-.3,7.3.6,7.4-.5-2.5-2.8-5.4-.7-7.4-.5s-2.1-.1-3.2,0l-1.3-.9-.8.9c-.1,0-.7,1.4-2.5,1.1s-1.1-1.6-1.7-2.2c-3.1-2.7-3.1-3.4-7.9-3.2-1.4,0-2.3,1.1-2.6,1.1-4,.5-2.8-1.8-3.9-2.1-2-.5-4.5.4-6.6-1.1.6,5.8,1.7,3.8,6.3,3.2.2.2-1.6,2.5-2.1,3.1-.9.2-.9,0-1.1,1.1-1.1,1.1-.6,2.8-3.1,2.1.4-6.7,1-7.4-5.3-9.5s-.7-1-2.1-1.1l-.6-.8-4.6.8c-.3.9,1,1,1.1,1,.2.6-.2,1.6,0,2.1.1,5.5-6.6-1.9-6.8,3.2l-2.6-3.2c.3-.9.1-4.1,0-5.3,1,.9,1.6,2.2,2.6,3.1l5.8-5.2c-5.4.6-5.4,1.1-9.4-2.1-.3,1.5.9,2.9,1,4.2-2.5-2.3-4.5-4-8.4-4.2,4.7,4.7-.5,4.9-1.1,6.3-6.3-.6-3.3-2.8-4.2-6.3s-1.5-1.5-2.1-2.1c-.8-.9-3.9-4.3-5.2-3.1-2.3,2,2.7,1.8,2.1,3.1l-5.2,1.1c1.5-4.3-.4-7.2-5.3-7.4v-3.2c14,5.9,39.2,12.3,54.7,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M364.9,1095.6c.3,6,3,13.7,5.5,19.2,1.8,3.9,7,10.1,8.1,12.9s-.3,1.7-1.6,1.6c-11.6-.6-34.6-13.4-33.2-26.9s4.5-3.4,5.3-7.9c5.6.6,10.3.7,15.8,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.1,1128.1c-17.1-6.1-34-19.7-38.9-37.8,4.4.3,5.4,5.6,7.8,8.4s15.2,15.9,17.8,17.9,5.7,1.6,9,4.6,5,6.1,4.2,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M331.3,1139.7l23.6-2.1c3,1.5,19.5,1.1,20.5,2.1s.1,2.8,0,3.1c-.8,1.3-8.5,1.1-10.5,1.1-5.1,0-10-1.3-14.7-1.1s-3-.1-2.1,2.6,2.1.4,2.1.5c4,5.6.5,3.8,0,4.2h-1.1c-.3,0-.7,0-1.1,0-.6-4.3-3.8-3-6.3-4.2-3.6-1.8-7-4.5-10.5-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M280.8,1115.5c16.4,10.4,30.3,19.3,48.4,27.3l-2.1,1.1c-17.9-7.1-33.9-13.9-48.4-27.3l2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M383.8,1089.3c11.5,1.7,23,2.6,34.7,2.1.2,1.5-1.8,1.4-2.9,1.8-6.9,2.6-20.1,3.5-27.6,3.4.8-4.6-1.4-3-5.3-3.2l1-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.1,1091c.5.7,2.5-.2,1.7,2.5-2.2,1.7-12.9-9.9-14.5-12.3-4.8-7-9.4-19.2-9.6-27.7l8.6,20.3c3.7,6.5,9.4,11.3,13.9,17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M385.9,584.7c1.2.7,2.7-.2,3.2,3.2,0,2.8,0,5.6,0,8.4l-8.4,2.1c-3.3-4.1-1.5-14.8,5.3-13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M293.4,568.9c.5-1.4,5.7-1.6,1.1-6.3,4,.2,5.9,1.9,8.4,4.2.1,1.2.3,4.3,0,5.3-2,7.2-12.3,4-9.5-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M318.6,570l-2.1,7.3c10.5.9,3,5.9-3.1,6.3-.4-.4,1.2-2.7,1-3.6-.3-1.6-3.3-.9-3.1-2.7,5.9-1.4,2-3.1,1-5.3s.2-1.5,0-2.1c1.3.5,3.5-1.1,4.2-1.1,1.4,0,1.7.9,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M344.9,575.2c1,4.8,1.7,5.8,6.3,4.2.4,1.7-.8,2.3-2.1,3.2-4.7,3.2-5-5.1-8.1-6.1s-10.4,1.9-6.7-3.3c.3,0,1.2-1.1,2.6-1.1,4.8-.2,4.9.5,7.9,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.8,1148.1c1.8.7,4.4,1.5,6.3,2.1s.7,0,1.1,0l1.1,1.1c-.3.1-.5,1.1-1.5,1.1-3.8.2-17.2-6.8-21.6-8.5l2.1-1.1c4.1,1.8,8.5,3.7,12.6,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.2,562.6c-2.6,4.3,1.5,7.8-5.7,6.3s-4.1-2.3-3.7-5.2c4.9,1.1,5.2,1.6,7.4-3.2.6.6,1.9,1.4,2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M389.1,599.4c-1.4.2-5.7,1.6-7.4,2.1h-3.1s2.1-3.2,2.1-3.2l8.4-2.1v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M259.8,547.9c1.8.7,5,4.5,1.6,5.3s-4-4.5-4.7-5.3c.9.2,2.5-.3,3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.5,591c-3.2-3.4,5.9-.9,6.6-1.1,1.8-.6,1.8-3.7,3.8-4.1-.2,4.6-7.5,8.3-10.5,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.8,1146c2.5,1.2,5.7-.1,6.3,4.2-1.9-.6-4.5-1.4-6.3-2.1v-2.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266.1 563.7 268.2 561.6 269.2 564.2 266.1 563.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.8,587.8c-.4.7-1.8-.6-1-2.1s1.8.6,1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M437.4,526.9c7.4.3,14.7.8,22.1,1.1,1,0,2.1,0,3.2,0,37.7,1.3,74.4,1.4,112.5,1.1,49.6-.5,92.8-1.7,142.1-7.7,1.8-.2,3.4-1.5,5,.4-10.7,2.2-21.5,4.7-32.2,7.2l-25.6,3.3c-25.3.6-53.8,5.8-79.9,7.4-52,3.2-102.5,2.6-154.5-2.1-17.9-1.6-34.8-3.8-52.6-6.3-8-1.1-18.8-2.3-26.3-5.3-.1-.5-.6-1-1.1-1.1-1-.1-2.1.1-3.2,0,.8-1.9-9.2-7.8-3.7-7.4,8.8.6,18.7,3.9,27.5,5.1,22.6,3.1,44.1,3.3,66.6,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M423.8,524.8l4.2,1.1c3.1.2,6.3-.2,9.5,0v1.1c-22.5-1.1-44-1.2-66.6-4.3-8.8-1.2-18.7-4.5-27.5-5.1-5.5-.4,4.5,5.5,3.7,7.4-11.2-1.3-24.9-4.8-36-7.7-2.8-.7-7.6-1.4-9.2-3.9l9.5-1c-6-1.5-12.4-2.2-17.9-5.3-.2,3.8,4.4,4,6.3,6.3-5.7-.5-6.6-.6-11.6-3.2-6.8-3.5-13.6-5.7-19.9-9s-8.9-5.5-11.7-8.8c53,21.4,110.4,28.3,167.1,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M459.5,527.9c-7.4-.3-14.7-.7-22.1-1.1v-1.1c7.2.4,15.1-.3,22.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M428,525.8l-4.2-1.1c2.1.2,4,1,4.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M254.5,500.6c11.2,2.3,22,9,33.6,9.5,5,2.5,5.8,2.7,11.6,3.2s1.4,0,2.1,0c1.7,2.5,6.4,3.2,9.2,3.9,11,2.8,24.8,6.3,36,7.7s2.1-.1,3.2,0c.3.4.6.9,1.1,1.1,7.5,3,18.2,4.1,26.3,5.3,1.2,1.5,3.6.3,3.1,2.1-2.1,0-4.2,0-6.3,0s-4.2-.1-6.3,0l-73.6-14.7c-15.9-5.9-30.5-9.4-46.2-16.8-1-3.5,3.5-1.6,6.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M254.5,500.6c-2.8-.6-7.3-2.4-6.3,1.1-.8-.4-1.4-.7-2.1-1.1.4-1.4-2-3.4-3.2-4.2,3.8.6,8.7,1.6,11.6,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M243,496.4c1.1.8,3.6,2.8,3.2,4.2-5-2.4-5.6-1.9-9.5-6.3,3,.8,2.8-.3,6.3,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M236.7,494.3c-.6-.2-1.5.1-2.1,0l1.1-1.1c.3.4.7.7,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M290.3,520.6c-8.4,12.6,6,24,9.5,35.7-10.1-2.8-19.8-6.3-29.4-10.5.6-2.5-.5-3.5-1.5-5.3-5.4-9.8-10.9-19.6-14.2-30.4,9.4,3.6,25.6,7.8,35.7,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.9,522.7c5.9,3.8-5.1,6.7-5.2,11s12.3,23,10.5,24.7c-3.6.8-6.4-1.2-9.5-2.1-3.4-11.7-17.8-23.1-9.5-35.7,4.3,1.1,9.2,2.2,13.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1021.8,690.9c.4.5,1.8-1.5,3.2,4.2-2.8.7-2.6-2.1-3.2-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1033.4,759.2c0,.9,3.2,3.7-1.1,3.2,0-1.2-.3-2.6,1.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1032.4,728.7c4.3-.5,1.1,2.3,1.1,3.2-1.4-.5-1-2-1.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M933.5,914.8c.1,1.8.4,2.5-1.6,2.1l-.5-1c.7-.6,1-1.2,2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M696,601.5c-.4,6.9-5.4,19.4-7,27.1-20.5,95.3-9.6,194.3,7.3,289.5,5.4,30.5,13,60.7,17.6,91.2-.7,1-8.4-15-9.3-16.5-5.8-10-13.5-19.1-18.1-29.8-1.9-.2-1,2.4-.9,3.5.9,10.2,3.4,16.2,2,26.9-8.3-39.9-18.2-79.9-23-120.5-9.2-77.6-4.1-159.6,17.2-234.8,2.8-9.8,6.3-22.9,10-32.1s1.1-4.7,4.2-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M460.5,1143.9c-.2,0-1.2-1-2.5-1.1-2.9-.3-6.1.3-9,0v-2.1s16.8,0,16.8,0l-11-2.1c-16.4,1.2-28.7-.1-44.3-4.1-1.7-.4-3.1,1.1-2.6-2.1,5.4.2,10.9-.2,16.3,0,23.7.8,45.3,2.6,69.3,1.1,34.5-2.2,68.5-10.2,103-11.6,10.7-.4,21.4.4,32.1,0-1.1,13.6-3.4,8.2-11.9,8.5-14.2.4-30.6,8.4-46.5,4.1l-21.5,2.1c12.8.1,25.5,2.5,38.3,3.2,10.6.6,21.8-.1,32.1,0,1.1,0,2.1,0,3.2,0l-2.1,5.3c-.7,0-1.4,0-2.1,0,1.5-3.1-7.4-3.5-6.3,0-32.2.3-64.5,1.2-96.7,1.1.1-3.7.7-2.9-2.6-3.2-9.9-.8-20.6.7-30.5,0-5.9-.4-11.3-5.3-15.3,1.1-2-.2-4.3.2-6.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M748.6,725.6c4.4,0,3.3-4.9,6.3-6.3,0,4.4,0,8.8,0,13.1.9,41.7,7.5,82.1,19.7,122.2.6,1.8.6,6.2,3.4,5.5,3.8,19.1,10,37.6,13.7,56.8l-16.7-30.1c-3.5-8.4-7.7-16.1-10.7-24.6s-2.8-11.6-4.4-19.2-4.2-9.8-4.5-10.2c-1.4-1.8-3.1-.3-4.7,0-.3-1.9-.8-3.9-1.1-6.3,3,0,3.4.9,3.1-2.6-.5-6.6-3-16.3-4.2-23.2-.3-2,1.2-4.2-2.1-3.6-1-23.6.2-48,2.1-71.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M682.3,593.1c-8.6-1.4-18.2,1.9-26.9,3-14.4,1.8-29.6,3.6-44,4.3-4.4.2-9.3.2-13.7,0s-3.9.8-3.7-1c28.9-1.8,59-5.5,87.2-12.1,21.7-5,36.6-14.9,59.5-19.4,16.3-3.2,30.8-8.6,46.7-14.3,4.3-1.5,8.5-6.1,5.3,2.6s-.9.7-1.1,1.1h-5.3c0,.7-.2,1.6,0,2.1.4,1.2,2.1,1.6,3.2,2.1,0,.7,0,1.4,0,2.1-.4-.2-1.7.2-2.1,0s-.5-2.2-2.6-2.1-.3,1.8-1.2,2.1-2-.2-2.4,0c-1.6.7-2.9,1.6-4.2,2.1-.7-1.7-3.1-.7-4.2-1.1s-.3-1.9-2.1-1.7-2.6,4.1-4.9,4.7-8.5-3.2-10.8,2.2c3.2,0,6.3-2.1,9.5-.5l-2.1,3.7c-.5,0-1.5,1.1-2.6,1-3-.3-3.9-5-5.8,3.2l-2-1c.1,1.3-.7,2.1-1.1,3.1-1-.7-2.2-1.3-3.2-2.1-9.9-7.9-7.7,4.6-11.1,5.2s-3.9-1.7-5.7-2.1c.8-1.1,4-4.3,3.1-5.3-1.4-1.5-4.7,3.7-5.2,4.7,0,1,1.4.4,2.1.5-.7.9-.1,3.8-3.1,3.1l1-7.3c-6.8-1.4-3.2,3.2-4.2,4.2s-9.1-.6-12.9,1.3-6.5,7.8-7.1,8.2-3-2.7-4.8-2.9c-3-.3-6.4,2.1-8.8,2.9s-1.6-.2-2.1,0l-3.2,1.1c-1,.4-3,1-3.2,2.1ZM785.3,557.4c-6.2-2.4-16.6,9.3-6.4,4.6l6.4-4.6ZM753.8,570l-8.4,3.1c4.4,1.2,8.2,2.9,8.4-3.1ZM740.1,572.1c-1.9-1-6.9,1.5-5.2,3.1s6-2.6,5.2-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M804.3,556.3v1.1c-4.2,0-24,71.8-27.8,79.9s-8.7,11.1-6.8,20c-2.5.2-1.9.4-2.1-1.6-.4-2.8-.3-8.8,0-11.6.5-4.9,3-10.4,3.2-15.7.1-3.7-1.2-7.3-.9-10.2,1.3-12.2,10.7-29.8,14.7-41.2s.2-4.5-.2-6.9c3-1.3,9.8-.6,8.4-5.3,1.3-.2,2-.6,3.2-1.1,3.5-1.3,1.2-.9,2.1-2.1,1.8-2.4,2.9-6.1,3.2-6.3.7-.5,2.5,1,3.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M726.5,1130.2c-3,1.5-6.2,3.9-9.5,5.3-2.1.9-5.9,1.3-8.7,2.4s-4.7,1.3-5,2.9l26.3-4.2-1,6.3c-4.2,2.1-10.5,7.9-15.8,9-3.1.6-4.5-.7-6.6-.4s-15,6.7-19.7,8.2c1.5-6,10.5-3.3,8.4-11.6,3.6,1.8,5.1-.9,8.9-1.2s7.6,2.5,7.9-1.4l-1.7-1.4-89.7.9,2.1-5.3c16.1,0,35.3,1.3,51,0s31.9-6.4,46.6-9.1c1.7-.3,5.1-1.4,6.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M783.2,1116.6c5.1.1.5,2.4-1.1,4.2-18.5,21.5-75.2,43.6-103,50.5-8.3,2-17.3,2.5-25.2,3.2,26.8-7,51.6-14.4,76.7-26.3,9.1-4.3,17.7-8.5,26.3-13.7s18.7-11.1,26.3-17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M733.8,1141.8c-.1.1.4,1.4-.2,1.9-1.4,1-3.9-1.6-2.9,4.4-25.1,11.8-49.9,19.3-76.7,26.3-1.4.1-2.8-.2-4.2,0,2.6-1,3.7-2.5,5.3-4.7l-2.1-.5c10.2-2.4,23.6-6.3,33.6-9.5,4.7-1.5,17.3-7.9,19.7-8.2s3.5,1,6.6.4c5.2-1.1,11.5-6.9,15.8-9s3.9-.3,5.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M733.8,1141.8c9.3-8.3,21.1-14,30.5-22.6,5.9-5.4,5.7-6.2,13-11.2.6-.4,11.4-9.9,9.1-4.6-.3.8-2.2,2-3,3.3-5.2,9-8.1,12.6-16.5,19.3-3.4,2.7-8.7,3.6-10,8.4-8.6,5.2-17.2,9.4-26.3,13.7-1-5.9,1.6-3.4,2.9-4.4s0-1.8.2-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M726.5,1130.2c5.1-2.5,12.2-5.5,16.7-8,1-.5,3.3-4.5,4-4.6,1.3-.1,2.8.9,4.6.6s10.1-4.1,10.5-3.7c2.5,2.7-4.1,4.8-4.9,5.6-11.5,10.1-21.5,10.3-35.8,15.2-1.2.4-3.8,2.1-4.5.3,3.3-1.4,6.4-3.8,9.5-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M746.5,797c3.3-.6,1.8,1.6,2.1,3.6,1.2,7,3.7,16.6,4.2,23.2s-.2,2.6-3.1,2.6c-1.1-9.8-2.7-19.6-3.2-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M762.2,573.1c1.7,0,3.5,0,5.3,0-.9,7.8-8.1,9.6-13.7,4.2,1.9-8.2,2.8-3.5,5.8-3.2s2.2-1,2.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M750.7,579.4c-.9,2-1,4.7-2.9,6.4-3.6,3.1-10.9.5-8.2-3.3s6.7-1.9,7.9-5.2c1,.8,2.1,1.4,3.2,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M690.7,590l1.1,5.3c-.3-.2-.8.1-1.1,0-4.6-2.4-2.2.4-4.4,1.4-2.2,1-4.1.4-6.1.7-.4-6.1,2.6-1.1,3.1-2.6-.2-.5-1.1-1.3-1-1.6.1-1.1,2.2-1.7,3.2-2.1s2.1-.7,3.2-1.1,1.5.2,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M724.4,585.7v1.1h-6.7c-1.9-.2-1.1-6.3,3.9-5.1s2.2,3.2,2.8,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M787.4,563.7c.7,5.9-7,5.9-6.3,0,.4-.2,1.6.3,2.4,0s.5-2.1,1.2-2.1c2.1,0,2.1,1.8,2.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M724.4,585.7c0,.1,1.8-.5,2.1.7.6,2.2-.2,4.6-1.1,6.7s-1,2-1.1,2.1c-3.7,3.3-15.3,3.5-16.8-2.6,2.5.3,4.5,3,7.1,3.5,5.4,1,12.5-3.4,9.7-9.3v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M810.6,994.6c4.9-1.3,4.7,5.6,0,4.2,0-1.4,0-2.8,0-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M776.9,565.8c-.6.3-1.2.7-2.1,1.1h-3.2c0-.5,0-1.1,0-1.6l1-.5c1.1.3,3.5-.7,4.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M809.5,987.3c4.3-.5,1.1,2.2,1.1,3.2-1.3-.5-1.1-2-1.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M687.6,995.7c4.1-.4,1.1,1.5,1.1,2.1-1-.3-1-1.2-1.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M774.8,566.8c-.6.2-2.7,2.7-3.2,0h3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M786.9,1099.8c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M764.3,862.2c-1.6,1.5-.6,3.1-.2,4.8,6.9,27.9,20.8,55.9,33.8,81.4l-1.1-13.1,1.1-3.7c3,18.4,7.9,36.2,5,54.9-1.1,6.8-3.3,14.1-4.9,20.8l7.3-10.5c-.1,14.1.6,28.4-1.2,42.4-2,16-6.9,30.9-15.3,44.7-6.5,10.7-14.1,19.2-26.7,22.2l17.2-22.2c1.3-2.7,4.1-6.1,4.8-8.9,1.1-4.6-8.4,4.7-10.4,3.2,4-9.2,7.6-19.7,9.3-29.6,13-73.5-22.8-142.7-32.5-215.9,1.6-.3,3.4-1.8,4.7,0s4.4,9.5,4.5,10.2c1.6,7.6,1.7,11.3,4.4,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1073.3,683.5c.6.5,5.6,12,6.4,13.9,11.9,26.2,6.9,63.5.4,91.3-15.2,65.7-65.4,123-118.4,162.3l-19.9,13.2c-.3-2.1,1.8-3.4,3.1-4.7,6-5.8,13.8-11.1,20-16.8,43.5-39.7,88.4-91.9,108.3-148.2,9.8-27.9,7.1-57,2.8-85.9s-3-16.4-5-24.5c-.1-.9,2-.6,2.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1078.6,688.8l-23.7-36.7c-25.2-31.8-60.5-53.8-102.4-52.7-.2-1.8,2.4-1,3.7-1,8.1-.3,17.1-.2,25.2,1.1,1.7.3,3,1.6,5.3,2.1s5,.7,4.8-1.1c-15.2-5.7-31.1-10.4-47.3-11.6v-3.1c15.5.9,29.9,1.9,45,6,37.7,10.3,67.2,37.2,82.7,72.8,3.3,7.4,7,15.9,6.9,24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1042.9,772.9c-.3,2.5,0,3.1,0,5.3-4.1-.4-1.1,1.6-1.1,2.1.1,2.1-1.5,8-2.1,10.5-2.9-1-4.6,6.9-3.2,8.4-1.9,5.4-4.1,10.5-6.3,15.8-2.9-.7-2.4,2.1-3.2,4.2-13,37.2-58.7,82.3-88.3,108.8-20.5,18.4-55.6,40.5-71.5,60.4-3.7-1.7-12.2,9.9-13.7,8.4,4.8-10.3,14.2-18,22.6-25.2s22-19.9,32-27.4c59.7-44.5,110.5-93.9,131.9-168.2.5-1.7-.2-3.7,2.6-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M885.2,617.3c3.9,2.4,23.1-2.3,25.2,1.1s-8.2,6-9.4,7.4,1,1.6,1,2-1,.7-1.1,1.1c-.7,0-1.4,0-2.1,0-3.8.1-1.5,1.7-2.1,2.1-1.9,1.4-20,7.6-25.2,10.5-3.3-4.4,2.4-5.8,3.7-8.4,1.7-3.6-1.7-5.3,4.7-3.1-.1-.8.2-2.9,0-3.1-.5-.5-11.9,1.2-13.7,1.5-15.2,2.9-32.2,12.8-36.7,28.4,5,5.3,12.1-1.6,16.5-2.4,2.3-.4,3.2.9,3.4.9-2.6,3.1-6.3,5.9-9.5,8.4-5.6,4.5-24.6,20.2-27.3,7.4l-4.2,2.1c0-1,0-2.1,0-3.1,6.4-11.6,15.3-21.4,25.9-29.3,15.4-11.4,29.5-16.8,47.6-22.3l.5,1,.5-1c.4-.1,1.1-.8,2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M885.2,617.3c27.8-7.5,52.6-9.7,80.7-1.3,1.8.5,25.6,9.1,23.4,10.8-8-2.8-16-4.7-24.7-5.2-21.1-1.4-42.3.3-62.5,6.3,0-.5-1.3-1.8-1-2,1.2-1.3,11.8-3.6,9.4-7.4s-21.2,1.2-25.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M870.5,601.5l-1,3.1c22.1-2.5,2.8,4.1-4.2,7.9s-7.7,5-11.5,7.4c3.9,1.7,7,.2,10.4-1.1s3.3-1,1.1,1.1l-20.7,9.8-23.5,15.9c.3-2.5-.8-6.3.5-8.4s2.3-1.3,3-2.2c11.4-15.2,26.9-29.4,45.8-33.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M858.9,974.7c.3-.2.8-1.4,1.9-2s11-3.6,7.6,0-8.1,2.9-8.4,3.2c-.4.6,1.5,3.8,1,5.2-6-.9-6,.7-5.3,6.3-3,3.5-7.3,9.6-9.5,13.7-3-.5-2.6,0-3.7,2-1.8,3.1-4.4,9.2-5.7,12.7-3.2.5-2.1-1.2-1.6-3.2,1-5.1,3.6-9.9,4.8-14.7s0-.7,0-1.1.7-.3.7-.5-.7-.4-.7-.5c-.1-1.1-1.1-2.1-1.1-4.2s1-.3,1.1-1.1c.2-1.9-.5-6,.2-7.2s7-1,6.1-4.4c.6,0,1.5,0,2.1,0s.9-.6,1.1-1.1c.6-.1,1.5.1,2.1,0,3.6-.8,4.5-1.7,7.4-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M845.3,1068.2c-.4.3-6.2,4.3-6.6,4.5-3.7,1.6-5.6,1.1-8.2-1.8-6.4-7.3-.5-21.4,1.1-30l1.3,11.8c.9,3.9,1.9,8.8,6.7,9.2s2.7-.9,3.5-1,.7,0,1.1,0c1-.3,1.4-.8,2.1-1.1,4.3-1.9,7.6-4.6,11.5-6.8-4.6,4.5-7.7,11.1-12.6,15.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1039.7,653l-38.9-35.7c18.1,5,35.3,16,38.9,35.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M821.1,623.6c.7-.3,2,0,3.2-.5,2.2-.9,4.6-4.1,7.3-2.2-6.7,8-12.6,13.8-16.8,23.7-1.2-.7-.6-4.8-3.2-2.6s-5.3,12.1-9.4,15.3c1.1-3.5,1-7.5,2.1-11,1.6-4.6,3.4-3.8,3.6-10s2-3.7-1.6-3.2c.7-1.6,1.7-3.3,2.1-4.2,3-3.9,4.8-1.7,7.6-2.3s3.7-2.5,5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1034.5,673l-32.6-32.6,13.3,6.1c9.7,6.1,16.9,15.1,19.2,26.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M835.8,1052.5c-.1-1.3-.3-8.4.5-8.4,3.1,10.5,7.1,12.2,17.3,8.4,0,2-6.2,6-7.4,6.3s-1.4,0-2.1,0c-1.4,0-2.8,0-4.2,0-3.5-2.2-3.7-1.1-4.2-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1039.7,755c.2-6.4.3-13.6,0-20,1.8,5.7,1.8,14.3,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M940.9,964.2c1.1,1.1-2.1,4.2-3.1,3.1s2.1-4.2,3.1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1013.4,665.6c-.5-.7-2.5-1-2.1-3.2.9.9,3.6,1.5,2.1,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M935.6,968.4c.6,2.8-.8,1.8-2.1,2.6-1.8,1.1-4.2,3-6.3,3.2l8.4-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1038.7,763.4l1.1-3.2c-.1,2.2-1,3-1.1,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1037.6,771.8l1.1-3.2c-.3,1.8-1,3-1.1,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1038.7,722.4l-1.1-2.1c0,.1.8.3,1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1037.6,717.1l-1.1-2.1c0,.1.7.4,1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1036.6,711.9c-1.1-.3-.9-1.2-1.1-2.1,1,.3,1,1.2,1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1010.3,661.4c-1.4-1.4-2.6-2.9-4.2-4.2,2.5.1,4.1,1.8,4.2,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1036.6,776l1.1-2.1c-.3,1.7-1,2-1.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M882,618.3c.3,0,.7,0,1.1,0l-.5,1-.5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M972.4,946.3c.8.8-4.5,7-5.4,7.8-23.3,22.9-56.4,44.4-81.9,67.4-5.1,4.6-9.3,10.7-15.7,13.7,5.8-15.1,18.4-25.6,29.4-36.8l73.6-52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M859.4,998.9c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M867.3,988.3c15.9-19.9,51-42.1,71.5-60.4,29.6-26.5,75.2-71.6,88.3-108.8,3,.7,2.3-2.2,3.2-4.2,2.2-5.3,4.4-10.4,6.3-15.8s2.3-5,3.2-8.4,2.2-8.4,2.1-10.5c1,0,1.1-1.3,1.1-2.1,0-2.2-.3-2.8,0-5.3.6-5.6,2.7-11.4,3.2-16.2,2.2-20.2-4.2-52-12.5-70.7-2.3-5.2-6.5-9.5-7.5-15.1,30.9,37.4,34.2,91.6,17.9,136.1-26.6,72.7-98.2,121.8-156.1,168.7-7.6,6.1-15.6,14.2-23.2,19.9s-2.7,2.1-3.6,1.6c2-3.1,4-6.1,6.3-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1039.7,728.7l-1.1-1.1c0,0,1,.3,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1035.5,780.2l1.1-1.1c-.2.8-1,1-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M776.4,581.5c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M846.3,978.9c.8,3.4-5.4,3.2-6.1,4.4s0,5.3-.2,7.2l-1.1,1.1c0,2.1.9,3.1,1.1,4.2v1.1c0,.4,0,.7,0,1.1-5.3,1.4-6.1,9.6-7.6,14-.6,1.7-.4,3.4-2.9,2.8.4-2.1.6-4.2,1.1-6.3v-1.1c.1-.6-.1-1.5,0-2.1,2.1-1.4,2.2-4,2.1-6.3.7-2.2,1.3-4.2,2.1-6.3s3.3-10.2,4.2-11.6,1.7-.4,2.4-1,.8-2.1,1.5-2.2c1.5-.2,2.7,1,3.5,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M833.7,977.8c-.4,1.4-.5,5.3-1.3,6.1s-1.6,0-1.9.2c-1.7.9-3.3,1.9-5.3,2.1-.5-1.6-1.5-3.4-2.1-5.3-.9-2.7-3-4.9-2.1-8.4,1.5-1.8,9.3,8.8,12.6,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M851.6,976.8v1.1c-.6.1-1.5-.1-2.1,0s-.9.6-1.1,1.1c-.6,0-1.5,0-2.1,0s-2-1.3-3.5-1.1-.8,1.5-1.5,2.2-2.2.8-2.4,1h-1.1c.4-.7-.9-4.3,1.7-5.2s8.4,2.1,11.9,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M837.9,981h1.1c-.9,1.4-3.2,9-4.2,11.6-1.4-3.4-1.1-8.1,1.1-11s2-.4,2.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M830.5,986.2v1.1c-.6,1.9-2,4.6-3.2,6.3-.2-1.5-1.6-4.6-2.1-6.3s0-.7,0-1.1c1.9-.2,3.6-1.2,5.3-2.1,0,.7,0,1.4,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M858.9,974.7c-2.9,1.5-3.7,2.4-7.4,3.2v-1.1c.7-.2,3.6-3.8,7.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M820,1053.5c-1.8-.6-1.3-3.2,0-4.2,0,.4,0,2.6,0,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M830.5,1005.2c.6-2.5,1.4-4.2,2.1-6.3.1,2.3,0,4.9-2.1,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M830.5,1008.3c0,0-.2-.2,0-1.1v1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M830.5,987.3v-1.1c.1.8.4-.3,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M870,969.4c.7.4.7.7,0,1.1v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M849.5,655.1c-.2,0-1.1-1.3-3.4-.9-4.4.8-11.5,7.7-16.5,2.4,4.4-15.6,21.5-25.5,36.7-28.4,1.8-.3,13.2-2,13.7-1.5s-.1,2.3,0,3.1c-6.4-2.2-3-.5-4.7,3.1-1.2,2.6-7,4-3.7,8.4-4.6,2.6-18.2,13.5-22.1,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M898.9,628.8c.2,2.2.1,2.4-2.1,2.1.6-.4-1.7-2,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M768.5,519.5c-1.5,5.8,4.5,7.7,5.8,12.6,2.8,10.5-5.1,17.4-8.4,26.3l28.9-10c2.2-1.5,10.1-20.7,12.1-24.6s1-2.9,2.6-3.2c.2,7.1-6.7,14.6-8,21s.6,4.9.5,5.2-2,.5-2.9,1.8c-1.8,2.7-2.3,6.2-4.3,8.8-.4-1.2-1-1.2-2.1-1.1,3.2-8.8-1-4.2-5.3-2.6-15.9,5.7-30.3,11.1-46.7,14.3-22.9,4.5-37.7,14.3-59.5,19.4-28.2,6.5-58.3,10.3-87.2,12.1-.2,1.8,2.4,1,3.7,1,4.4.2,9.3.2,13.7,0,14.4-.7,29.7-2.5,44-4.3,8.7-1.1,18.4-4.4,26.9-3,0,.3.8,1.1,1,1.6-.5,1.6-3.5-3.5-3.1,2.6,2-.3,3.9.2,6.1-.7,2.3-1-.2-3.8,4.4-1.4-2.5,4-6,4.7-10.5,4.2,0-.7,0-1.4,0-2.1-2.3.3-6,1.2-7.9,1.2s-1-2.4-2.9-2.2c-11.5.8-24.1,4.1-35.4,5.3-5.8.6-12,.6-17.9,1.1-1.3-1.4-2.9-1.5-4.2,0-3.3.2-6.2.3-9.5,1.1l-.7-.9c-.7-.2-1.2.9-1.4.9-.7,0-1.4,0-2.1,0-1,0-2.1,0-3.2,0-1.8,0-3.5,0-5.3,0-3.8,0-7.7-.1-11.6,0s-5.7,1-7.4,1.1-2.1,0-3.2,0c-5.2.1-10.5,0-15.8,0-2.5,0-4.9,0-7.4,0s-6.3,0-9.5,0c-10.1-.1-22-1.5-31.5-1.1s-2.8,0-4.2,0c5.4,11.9-9.8,15.8-13.7,5.2-3.9,6.2-17,8.4-18.9,0s-.1-2.5,0-3.2c1.7-.2,3.7-.4,5.3-1.1,4,4.7-4.8,1.9-2.1,6.3s12.6,3,12.6-6.3.3-2-.2-2.9c-1-1.7-16.3-5-19.3-5.4-5.9-.8-9.9-.2-15.2-1.8-9.6-2.9-21-5.8-29.4-11,14,2.6,27.7,7.6,41.8,10.2,55.4,10.2,139.1,7.3,194.7-2.8,1.7-.3,2-1,2.1-1.1,1.2-.2,3,.3,4.2,0s2-1,2.1-1.1c5.4-1.2,9.7-2.8,14.7-4.2s7.1-.9,11.1-2.1,13.1-4.1,16.2-5.8,14.5-35.6,17.9-42.1v-2.6c-3.4,1.7-7.2-1.9-8.4-2.1.8-2.6,2.8-1.8,4.7-2.1,11.8-1.8,23.8-4.3,35.2-7.3,1.9,1.9,4.8.4,7.4,0l-7.3,3.2c0,1.7,3.7,2.2,4.8,2.2,3.5,0,4.2-2.3,4.7-5.3.9-.2,2.8-.7,4.2-1.1ZM745.4,565.8c17.9-3.5,32.5-22.6,16.3-37.8l-16.3,37.8ZM492.1,606.8l3.2-4.2c-3.9.6-10.1-.4-8.5,4.7s2.7.4,3.2,1.6c.9,2.5,0,5.9,6,3.4s0-10.8-3.9-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M806.4,510.1c-4.4,12.6-6.8,27.1-16.8,36.8-2.4-5.3.6-6.1,1.6-9.4,1.9-6,6.6-19.7,10.1-24.6,1.1-1.5,3.2-2.9,5.1-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M795.9,707.7c4.5.8.4-4.5,1.1-5.2,1.5-1.7,2.7,2.3,3.8,3,3.4,2,6.3.7,9.8.2-3.3,5.8-7.7,6.4-13.7,7.3-.8-1.5-.6-3.9-1.1-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M780.1,499.6c.8,0,4.8.3,5.3,1.1-10.2,4.2-20.8,7.5-31,11.6s-6.3,1.8-5.8,4.2c-8.8,2.1-17.6,3.4-26.3,5.3-1.6-1.9-3.3-.6-5-.4-49.3,6-92.5,7.2-142.1,7.7,5.5-2.3,12.5-.6,18.5-1s2.4-1.1,2.5-1.1c54-3.6,106-12.3,159-22.4s17-4.9,25-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M769.6,742.4c-1.6-.3-1.6-3.8,0-4.2,0,1.4,0,2.8,0,4.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "769.6 747.6 768.5 747.1 769.6 746.6 769.6 747.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M823.2,981c.6,1.9,1.6,3.7,2.1,5.3s-.1.7,0,1.1c-3.7,4.5-4.9,8.9-4.2,14.7-2.7.5-1.9-.4-2.4-2.3-.9-3.4-.7-5.9-.7-9.3s0-4.9,0-7.4,0-2.1,0-3.2l5.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M817.9,976.8c-2.3-2.8-.6-7.9-1.1-11.6,1.6,3.8,1.2,7.4,1.1,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M817.9,983.1c-2.4-.8,0-2.8,0-3.2,0,1,0,2.1,0,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M807.4,498.5h3.2s-3.2,3.2-3.2,3.2c-17.2,7.8-34.2,14.1-52.6,18.9-11.5,3-23.5,5.5-35.2,7.3-1.9.3-4-.5-4.7,2.1-2-.4-5.1.2-7.4,0-13.5-.9-29.2,1.8-43.1,2.1l25.6-3.3c10.6-2.6,21.5-5,32.2-7.2,8.7-1.8,17.5-3.1,26.3-5.3,19.4-4.7,40.4-10.3,58.9-17.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M764.3,520.6c-.5,3.1-1.2,5.3-4.7,5.3s-4.8-.5-4.8-2.2l7.3-3.2c.7-.1,1.4.1,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M679.2,1171.2v1.1c-.2,0-1.4,1.5-2.8,1.8-4.4,1.1-22,4-24,5.4s-4.8,10.3-6.6,13.4c-5.5,9.8-13.8,21.2-25.4,23.5-.2,1.9,2.4,1,3.5.9,10.4-.9,20.8-3.4,31.1-4.1-.3,4.5-6.2,5.4-9.7,6.6-6.8,2.3-13.8,3.4-20.8,5l6.3-5.2-36.2,3.2-9-1.1c22.2-3.2,40.4-15.7,46.2-37.8-11.6,1-23.1,3-34.7,4.2-39.2,4-78.4,4.2-117.7,1.1s-25.3-2.4-37.8-4.2c3.5,9,4.5,18.3,6.6,27.6s3.7,6,.3,5c-9.3-2.9-20.2-18.3-24.9-26.6-1.2-2.2-3.3-9.1-4.3-9.9-3-2.4-16.8-2.2-20.8-6.6,2.9,0,6.4-1.1,7.4-1.1,4.4,0,11.9,2.3,16.8,3.2,75.8,13.7,136.4,14.7,212.6,1.8,4.2-.7,10.5-3.5,14.5-3.9s2.8.1,4.2,0c7.9-.7,16.9-1.1,25.2-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M597.2,1188.1c-2,3.3-7.5,18.9-10.2,19.8s-6.4-.2-9.3.2c-26,3.3-54.6,3.4-81,2.1-5.3-.3-11-1.8-16.6-1.3-1.3-.4-7-10.4-7-12,0-3.6,6.3-4.1,6.3-7.9,39.3,3.2,78.5,3,117.7-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M379.6,1173.3c3.4,11.7,11,24,20,32.1,1,.9,8,4.4,6.3,5.8-9.4-.9-18.6-4-27.9-5.2s-1.5.2-1.5,2l74.6,25.2c-5.2.3-22.5-2.2-28.4-3.2-14.8-2.5-30.2-7-44.1-12.6s-17-7.3-23.1-10.5c-1.2-12.2,8.4-1.5,14.7-4.7-14.4-8.5-20.4-26-27.3-40.5,11.8,4.2,24.8,8.2,36.8,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M379.6,1173.3c3.8,1.1,16.3,1.8,18.9,4.7s1.5,6.3,2.6,9c3.2,7.8,18,22.3,25.5,26,2.4,1.2,10.3,3.1,10.7,3.5s.8,2.3-1.3,1.9c-10.5-2-21.6-1.8-31.8-5-2.8,3.8,3.9,3.7,7.4,5.1,15.5,6.5,34.8,9.6,51.9,11.7,32.8,4.1,65.7,5.5,98.8,3.2-10.4,3.3-21.4,1.7-32.1,2.1-2.8,0-5.3,1.1-8.3,1.1-23.4.5-47.3.3-70-5.3l1.1,2.1c-.7,0-1.4,0-2.1,0l-74.6-25.2c0-1.8-.6-2.3,1.5-2,9.3,1.2,18.5,4.3,27.9,5.2,1.7-1.3-5.3-4.8-6.3-5.8-9-8.1-16.5-20.4-20-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M463.7,1230.1c.8-2.6-4.8-3.4-6.3-3.7s-11.6-.2-8.4-2.6c46.5,3.8,93.1,3.2,139.8,3.2,1.1.9-2.6,4-2.9,4.1-5.6,1.6-17.1,1.7-23.4,2.2-33.1,2.3-66,.9-98.8-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.8,1161.8c7,14.4,13,31.9,27.3,40.5-6.3,3.2-16-7.4-14.7,4.7-2.3-1.2-11.9-8.3-12.6-10s1.1-1.7,2.4-1.4c3.4.8,6.6,3,10.2,2.9-.1-2.3-5.1-2.9-5.3-3.2s1.5-2.5.6-5.3-6.6-9.9-8.5-13.6-9-17.9-6.3-17.9c2.5-.2,5.3,2.6,6.8,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M317.6,1145c12.6,5.4,26.2,10.2,39.4,14.7,2.9,1,5.8,2.3,9,2.1,6.5,3.8,27.6,8.7,35.7,10.5.2,0,1.6,1.8,3.2,1.1h1.1c-.9,0-4.5,1.1-7.4,1.1s-.7,0-1.1,0c-.5-1.4-2-1-3.2-1.1-22.2-1.8-55.9-16.2-76.7-25.2-1.4-2.2-3.8-3.5,0-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M397.5,1174.4c-1.2,0-2.6.3-3.2-1.1,1.1,0,2.7-.4,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M593,1228c.7.4-.6,1.8-2.1,1s.6-1.8,2.1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.5,1249c29,3.7,59.6,5.6,88.8,6.4,23.2.6,46.8.2,69.9-1.1-.4,2.1-2.2,1.7-3.7,2.1-7,1.8-17.1,3.2-24.3,4.1-10.3,1.2-22.7,2.2-33,2.3-26.9.2-69.1-2.2-94.4-11.3-1.7-.6-4,.8-3.3-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M603.5,1249c-.3-1.6,2-1.3,3.1-1.6,8.9-2,23.2-5,32.1-4.8,1.5,0,6.4-.3,5.8,2.7-10.3,6.5-22.8,8.5-34.7,10l10.5-6.3h-16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M412.2,1246.9c-9.5-2.9-21-7-28.4-13.7,12.1,1.1,24.1,2.7,35.7,6.3.3,1.8-2.4,1-3.7,1s-8.6-.3-8.9,0c-2.4,1.8,3.7,2.8,4.5,3.2s1.3,1.9,1.8,2.1l-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M421.7,1248c-5.6,1.4-4.5.5-9.5-1.1l1.1-1.1c1.6.6,5.8,1.1,8.4,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M732.8,1155.5c-.9,7.1-5.8,15.2-9.7,21.3-3.7,6-8.8,13.5-14.5,17.6-.3,2,2,.6,2.9.3,4.4-1.5,8.3-4.2,12.8-5.6-11.6,11.1-21.4,10.1-33.2,19.8l-25.6,11.7c1.4-1,9.6-9,9.4-9.9-.5-3-7-3.9-9.4-4.3,1.2-1,1.9-2.3,2.7-3.7,3-5.6,8.2-19.8,11.1-23.6s7.1-1.8,6.2-6.9c5.1-1.3,10.2-4.8,15.8-4.2-.3,3.7-3.5,5.8-5.1,9.1-3.5,7.2-4.3,11.8-9.6,18.8s-9,7.2-2.7,6.8c15.4-1.2,24.9-17.2,31.7-29.3s5-12.3,6-13.4c1.6-1.7,5.6-1.7,7.3-2.5s3.2-1.6,4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M732.8,1155.5c6-2.6,15.2-8.9,20.5-10.5s1.8.1,1.6,1.6c-2.3,14.7-20.2,32.7-30.5,42.6-4.5,1.4-8.4,4.1-12.8,5.6s-3.2,1.7-2.9-.3c5.7-4,10.8-11.6,14.5-17.6,3.8-6.1,8.7-14.2,9.7-21.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M844.2,1058.8v2.1c-.3,0-.7,0-1.1,0-1.4-.2-2.2-1.5-3.2-2.1,1.4,0,2.8,0,4.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M814.8,1080.8c0,2.4.2,8.3,3.2,7.4-1.2,3.7-.8,1.4-3.4,3.2s-2.5,1.3-3.9,2.1c0-4.2,1.6-8.5,2.1-12.6h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M417.5,478.5c-.6.6-17.5,2.4-14.7,6.3,3,4.2,26.3,4.6,32.1,5.3s3.2.8,1.6,2.1l-70.4-2.1c-.4-1.8.4-2.2,1.8-2.9s9.2-3.5,10.8-3.9c7.3-2.1,18.7-4.8,26.3-6.3s12.7-3.7,12.6,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.3,478.5c-1.1,1.2-18.4,2.8-17.9-3.1,5.4.3,15.6-3.8,17.9,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M440.6,491.2c.7.4-.6,1.8-2.1,1s.6-1.8,2.1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M752.8,476.4c-4.1,0-3.3-1.2-5.3-3.2l.6-1c2.3.4,4.7,1.5,4.7,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M627.7,1038.8c-61.3,12.6-124.5,18.5-187.1,12.6.7-21.9,2.5-43.8,4.2-65.7,5.7-71.2,11-133,5.2-205-.1-1.8-3.3-19.5-1.6-19.5,49,25.9,105.6,35.1,160.3,41-.2,36,.4,71.9,3.2,107.7,3.3,43,10.8,84.7,15.8,127.7,0,.3,0,.7,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M395.4,583.6c1.3.2,4.4-.9,4.2,1-6.2,1.6-10.5.7-8.2,8.7s4.1-.3,4.5-.3,5,4.7,7.4,1.1-2.1-4.8-5.8-4.3c-1.5-1.1,8-3.9,9.3-4s2.1.9,2.3.9c.6,7.9-2.6,8.3-8.4,12.1,2.5,7.7,19.4,10,21.7,1.6s-6-7.6-5.9-11.6c4.6,2.6,6.9,4.5,7.4,10.5,3.6-3.9,1.8-8.7,9.4-7.3-1.1,2.7-6.8,4.4-6.1,7.7s4.5.6,7.2.7c-.5,2.8-5,2.5-4.2,4.7,2.4,6.4,19.4,1.6,13.7-6.8-1.1-5.6,3.3-1,6.3-2.1.8,2.8-3.1,2.6-3.2,3.8-.6,4.2,3.8,7.1,6.4,2.5-.2.4.2,1.7-.2,2.5-.9,1.8-3.9,1.3-3,3.3,1.9,4.5,15.7,4,13.7-5.8h1.1c.6,2.4,2.3,4.3,0,7.4-3.8,3.3-5.5,4-11,3.1s-6.9-6.3-7.4-6.3c-2,0-5.8,4.4-10.4,4.2s-8.2-6.9-11.6-6.3-1,2.4-2.1,3.2c-5.7,4.4-17.9,4.6-23.7.5s-5.1-9.6-9.5-8.9v-3.2c0-2.8,0-5.6,0-8.4s1.4-.9.9-2.4-3.5-3.5-3-3.9c3.4,1.8,5,1.7,8.4,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M535.2,604.7c-6.6,4.4,2.2,2.2,3.2,3.2s-1,4.6-2.9,5.1c-4.2,1.1-5.2-3.5-7.1-3s-1.5,4.8-6.1,4-4.5-4.6-8.1-4c-.4-4.8-2.7-5.3-7.4-5.3-.4,4.1,0,3,3.1,3.1l-4.2,2.1c-.3-1.1.2-2.9,0-4.2l-2.1,1.1c.2-.9-.1-2.1,0-3.2,9.5-.5,21.5.9,31.5,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M578.3,603.6c2.5,1.7,8.9,1.8,11.6,0,1.8,0,3.5,0,5.3,0,.1.7-.1,1.5,0,2.1s-.1.8,0,1.1c-4.1,1.7-7-1.6-6.3,5.3-.2,0-1.1,1.3-2.4,1.1-.4-1.7-2.7-2-2.8-2.2-.4-.6.4-3.5-1.7-4.1s-5.1,1.2-7.8,1-3.8-1.2-3.2-3.2c1.6,0,4.6-1,7.4-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M552,604.7l4.2,6.3c-1.6.4-3.2,3-5.9,3.2s-11.1-3.3-8.9-6.3,4.4,1.6,3.2-3.2c2.5,0,4.9,0,7.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M514.2,609.9c.5,6.5-10.1,5.1-11.4.3s.7-2.5.9-3.4l2.1-1.1c.2,1.3-.3,3.1,0,4.2,1.5,6.1,11-1.8,4.2-2.1s-3.5.9-3.1-3.1c4.6,0,7,.4,7.4,5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M565.7,606.8c7.5,1.2,2.7,8.3-2.4,7.2s-3.6-2.7-5-3c-.2-2.4,4.9-4.6,7.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M567.8,604.7l-2.1,2.1c-2.4-.4-7.6,1.8-7.4,4.2-.4-.1-1.7-.1-2.1,0l-4.2-6.3c5.2,0,10.5.1,15.8,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M583.5,611c-3.7,3.6-11.9,3.1-9.5-3.2,2.7.3,6.6-1.3,7.8-1,2.1.6,1.3,3.6,1.7,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M595.1,606.8c.3.7,4.1,1.8,1.1,4.7s-4.8.6-7.4.5c-.7-6.9,2.2-3.6,6.3-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M464.8,602.6c-.4-1.4-1.2-2.7-1-4.2l7.3,1.1c-1.4,2.6-3.6,3-4.2,6.3s-.1,2.5,0,3.2c-.6.4-1.6.6-2.1,1.1,2.3-3.1.6-4.9,0-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M616.1,602.6c-2.2.2-3.5,0-4.2,0,1.3-1.5,2.9-1.4,4.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M598.2,603.6c.5,2.8-.7,2.1-3.2,2.1-.1-.6.1-1.4,0-2.1,1,0,2.1,0,3.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M602.4,603.6c-.2,0-.7,1.1-1.4.9l-.7-.9c.2,0,.7-1.1,1.4-.9l.7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M416.4,583.6c.7.1,1.5-.1,2.1,0,8.4,5.1,19.7,8.1,29.4,11,5.2,1.6,9.3,1,15.2,1.8s18.3,3.7,19.3,5.4.2,1.9.2,2.9c-3.1-1.9-5.9-2.9-9.4-1.6s-.9,1.5-1.1,1.6c-1.6.6-3.6.9-5.3,1.1.6-3.3,2.8-3.7,4.2-6.3l-7.3-1.1c-.2,1.5.7,2.8,1,4.2h-1.1c-.6-2.6-7.3-4.2-9.3-3s-.9,2.2-1.2,3c-2.6,4.6-7,1.8-6.4-2.5s4.1-1.1,3.2-3.8c-3,1.1-7.4-3.5-6.3,2.1-1.9-2.8-7.5-2.1-10.5-2.1.4,1.4,1.3,2.7,1.1,4.2-2.7-.1-6.2,3.8-7.2-.7s5.1-5.1,6.1-7.7c-7.6-1.4-5.8,3.5-9.4,7.3-.5-6-2.8-7.9-7.4-10.5s-1.4-.8-2.1-1.1c-1.3-.5-1.4-.7-3.2-1.1s-1.4,0-2.1,0-.7-1-2.3-.9-10.8,2.9-9.3,4c3.8-.5,9-.4,5.8,4.3s-7-1.1-7.4-1.1-2.7,6.5-4.5.3,2-7.1,8.2-8.7c.2-1.9-2.9-.9-4.2-1v-2.1c7.6.8,13.1.8,21,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M369.1,573.1c13.3,1.3,29.4,5.5,43.1,7.9,1.8.3,4.9-.2,4.2,2.6-8-1.3-13.4-1.3-21-2.1-2.9-.3-4.7-1.3-7.4-2.1-3.8-1.1-6.1-2.2-10.5-3.2s-.7,0-1.1,0-.8-.8-1.7-1c-3-.5-6.5,1.3-5.7-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.9,566.8c-.1-1.3-1.4-2.7-1-4.2,4.1,3.2,4.1,2.7,9.4,2.1l-5.8,5.2c-1-.9-1.6-2.2-2.6-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M342.8,570c-2.3.3-5.1,1.9-8.7,1s-.7-1.6-1-1.7c-2.3-1.1-5.6,1.3-5-2.4,4.9,1.1,10,1.4,14.7,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.9,575.2c.6.5.9,2.1,1.7,2.2,1.8.3,2.4-1.1,2.5-1.1.7,0,1.4,0,2.1,0,1-.1,2.1,0,3.2,0v1.1c-.9.2-2.2,1.8-3.2,2.1-4.6,1.6-5.3.6-6.3-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.1,573.1c.3,0,.7,0,1.1,0-.8,3.5,2.7,1.6,5.7,2.2s1.4.9,1.7,1c-6.5.2-12.8-1.3-18.9-3.2,3.1,0,6.8-.3,10.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M354.4,576.3c2-.2,4.8-2.3,7.4.5,0,1.2-6,.2-7.4.5v-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M388,579.4l-10.5-3.2c4.4,1,6.7,2,10.5,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.1,571c2.6.2,4.9-1.1,4.2,2.1-2.6-.1-4.9,1-4.2-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M316.5,568.9c-.7,0-2.9,1.5-4.2,1.1,0,0-1.3-.1-1.1-1l4.6-.8.6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347,571c-.9,0-1.8,0-2.1-1.1.9,0,1.8.1,2.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.2,576.3c-.7,0-1.4,0-2.1,0l.8-.9,1.3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M350.2,1142.9v3.2c0-.1-1.9.3-2.1-.5-.9-2.8.3-2.5,2.1-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M350.2,1151.3l-1.1-1.1h1.1c-.2.1.2,1,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.6,539.5v2.1c-48.5,2.5-107,5-154.5-3.2v-1.1c52,4.7,102.5,5.3,154.5,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M707.6,530l-1.1,1.1c-27.9,2.3-55.7,6.3-83.6,8.4s-19.3.5-28.9,1.1-1.4,0-2.1,0c-2.4.1-4.7.9-7.4,1.1v-2.1c26.1-1.6,54.6-6.8,79.9-7.4,13.9-.3,29.6-3,43.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M430.1,537.4v1.1c-1.2-.2-4-.2-5.3,0s-.9.5-1.1,1.1c-14.8-2.1-29.8-2.6-44.7-4.2s-3.9.4-4.7-2.2c2.1,0,4.2,0,6.3,0,.4-1.7-2-.6-3.1-2.1,17.8,2.5,34.7,4.7,52.6,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351.2,525.8c-.4-.2-.8-.7-1.1-1.1.5,0,.9.6,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M299.7,513.2c-1.9-2.3-6.5-2.5-6.3-6.3,5.4,3.1,11.9,3.7,17.9,5.3l-9.5,1c-.7,0-1.4,0-2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M706.5,531.1l4.2,1c-3-.7-5.4,1.7-7.9,2.1-30,4.2-59.2,7.9-89.3,10.6-21.2,1.9-42.3,5-63.6,4.2-.5,3,.6,1.8,2.4,2.2,11.1,3,24.2,3,35.6,5.4,14.8,3.1,35.8,9.4,10.5,20.5l-38.1,9.7c39.1,1,78.3-3.2,116.1-12.6,2.2-.2,1.4.1,1.6,1.6.4,2.7-.3,6.1,0,9-5,1.4-9.3,3-14.7,4.2-1.8-1.8-2.4-1.4-2.1,1.1-1.2.3-3-.2-4.2,0l-2.1,1.1c-55.6,10.2-139.3,13.1-194.7,2.8-14.1-2.6-27.9-7.6-41.8-10.2-.6-.1-1.4.1-2.1,0,.7-2.9-2.3-2.3-4.2-2.6-13.8-2.4-29.8-6.6-43.1-7.9s-.7,0-1.1,0l-13.7-38.9c4.6.1,9.1-.8,13.7-1.1s4.2,0,6.3,0c.8,2.5,2.8,2,4.7,2.2,14.9,1.6,29.9,2.1,44.7,4.2l1.1-1.1c1.2-.2,4.1-.2,5.3,0,47.5,8.2,106,5.6,154.5,3.2,2.7-.1,4.9-.9,7.4-1.1l1.6,1,.5-1c9.6-.6,19.3-.3,28.9-1.1,27.9-2.1,55.7-6.1,83.6-8.4ZM540.4,547.9l-151.3-8.4c-.2,1.5,1.8,1.4,2.9,1.8,38.4,12.5,105.1,16.8,144.4,8.4,1.2-.3,4.2-.1,4-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M466.9,1143.9c4-6.3,9.4-1.5,15.3-1.1,9.9.7,20.7-.8,30.5,0s2.7-.5,2.6,3.2c-17.3,0-31.2-.2-48.4-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M611.9,1145c-1.1-3.5,7.8-3.1,6.3,0-2.1,0-4.2,0-6.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M785.3,557.4l-6.4,4.6c-10.2,4.7.2-7,6.4-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M753.8,570c-.2,6.1-4,4.4-8.4,3.1l8.4-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M791.6,557.4c-1.5,3.1-2,2-2.1,2.1h-3.2c-.2-.5,0-1.4,0-2.1h5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M740.1,572.1c.8.6-4.3,4-5.2,3.1-1.7-1.7,3.3-4.2,5.2-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M789.5,559.5c-.2.2,0,1.5,0,2.1-1-.5-2.7-.9-3.2-2.1h3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M688.6,590c-1,.4-2.4.8-3.2,1.1l3.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M798,561.6c-.9,1.2,1.4.8-2.1,2.1-.3-2.2-.1-2.4,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M652.9,1169.1l2.1.5c-1.6,2.2-2.6,3.7-5.3,4.7-4,.5-10.3,3.2-14.5,3.9-76.2,12.9-136.7,11.9-212.6-1.8l3.1-2.1c-4.1-2-7.4-.2-11.6,0,1.2-3.6,1.2-2.9,4.2-3.1s1.4,0,2.1,0l3.2,1.1c77.8,10.7,151.7,15.2,229.1-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1039.7,790.7c-.9,3.4-2.1,5.5-3.2,8.4-1.5-1.5.2-9.4,3.2-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1030.3,814.9c-.8,2-.2,4.9-3.2,4.2.7-2.1.2-4.9,3.2-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1042.9,778.1c0,.8,0,2.1-1.1,2.1,0-.5-3.1-2.5,1.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M840,996.8v-1.1c0,.1.7.2.7.5s-.7.4-.7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M838.9,991.5l1.1-1.1c0,.8-1,1-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M848.4,978.9c.1-.5.6-1,1.1-1.1-.1.5-.6,1-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M846.3,1058.8v1.1c-.7.3-1.1.8-2.1,1.1v-2.1c.7,0,1.5.1,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M714.9,530c1.1.2,4.9,3.8,8.4,2.1v2.6c-3.5,6.5-13.6,39.6-17.9,42.1s-12.4,4.7-16.2,5.8-7.9,1.2-11.1,2.1c-.3-2.8.4-6.2,0-9s.6-1.8-1.6-1.6c-37.9,9.5-77,13.6-116.1,12.6l38.1-9.7c25.3-11.1,4.3-17.4-10.5-20.5-11.4-2.4-24.5-2.4-35.6-5.4s-2.9.7-2.4-2.2c21.3.8,42.4-2.3,63.6-4.2,30-2.7,59.2-6.4,89.3-10.6,2.5-.3,4.9-2.7,7.9-2.1l-4.2-1,1.1-1.1c2.3.2,5.3-.4,7.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M745.4,565.8l16.3-37.8c16.2,15.2,1.6,34.4-16.3,37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M482.6,604.7c0,9.2-11.1,8.6-12.6,6.3-2.7-4.4,6.1-1.6,2.1-6.3.2,0,.4-1.3,1.1-1.6,3.5-1.4,6.3-.3,9.4,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M492.1,606.8c4-5.3,11.8,2.3,3.9,5.5s-5.1-1-6-3.4c3.1.7,1.8-1.6,2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490,608.9c-.5-1.2-2.9-.7-3.2-1.6-1.6-5.1,4.6-4,8.5-4.7l-3.2,4.2c-.3.5,1,2.8-2.1,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M589.8,603.6c-2.7,1.8-9.1,1.7-11.6,0,3.8-.1,7.7,0,11.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M663.4,588.9c-.1,0-.4.7-2.1,1.1-.3-2.5.3-2.8,2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M657.1,590c-.1,0-.4.7-2.1,1.1l2.1-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M817.9,502.7c2.2,1,.4,3.2-.2,4.6-3.3,8.2-5.8,15.6-8.8,23.8-1.1,2.9-3.9,6.5-4.6,9.1s3.7,2.4,2,5.6c-1.6,2.8-2.9,8-3.3,8.3s-2.8-.1-4.1.6-1.8,4.7-3.7,5.8c-1.2-.3-.2-2.3-.5-3.1,2-2.6,2.6-6.1,4.3-8.8s2.7-1.6,2.9-1.8-1-2.7-.5-5.2c1.3-6.4,8.2-13.9,8-21-1.6.3-2,2-2.6,3.2-2,4-9.9,23.2-12.1,24.6l-28.9,10c3.4-8.9,11.2-15.8,8.4-26.3-1.3-4.9-7.3-6.8-5.8-12.6,15.8-3.3,27.6-8.3,42-14.7,2-.9,5.4-1.2,7.4-2.1ZM806.4,510.1c-2-.2-4.1,1.2-5.1,2.7-3.4,4.9-8.2,18.6-10.1,24.6s-4,4.1-1.6,9.4c10-9.6,12.4-24.2,16.8-36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M371.2,1159.7c.7.1,2.1,2.1,4.2,0l43.1,11.6c-3,.2-3-.5-4.2,3.1,4.1-.2,7.4-2,11.6,0l-3.1,2.1c-4.9-.9-12.4-3.1-16.8-3.2h-1.1l-3.2-1.1c-8.2-1.8-29.3-6.7-35.7-10.5s-1.7-2.2-2.4-2.8-3.2.5-2.8-1.4c3.6.2,7,1.6,10.5,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M404.8,1173.3c-1.5.8-3-1-3.2-1.1l3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M371.2,1159.7c-6.2-4.3-15.6-4.4-18.9-11.6,7.7-3.1,6.4,2,11.6,5.7s8.6,2.5,11.5,5.9c-2.1,2.1-3.5.1-4.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M411.1,586.8l3.2,1.1c.7.3,1.4.7,2.1,1.1-.1,4,6.6,9,5.9,11.6-2.3,8.4-19.2,6.1-21.7-1.6,5.8-3.8,9-4.2,8.4-12.1.7,0,1.5-.1,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M443.7,598.4c5.7,8.4-11.3,13.2-13.7,6.8s3.7-1.9,4.2-4.7-.6-2.8-1.1-4.2c3,0,8.6-.7,10.5,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M453.2,602.6c.3-.7,1-2.8,1.2-3,2-1.2,8.7.3,9.3,3,2,9.8-11.8,10.2-13.7,5.8s2.1-1.5,3-3.3,0-2.1.2-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M510,607.8c6.8.3-2.7,8.2-4.2,2.1l4.2-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M621.4,1156.5c-.2,1.8,1.3,4.1,1.1,5.6s-3.4,1-2.1,3.8c-2.8.5-6.3.6-9.5,1.1-1-1.4-.2-3.2-2.5-3.1-7.1.3-15.6,3-22.7,4.2-1.4,0-2.8,0-4.2,0s-3-.3-4.2,1.1c-1.4,0-2.8,0-4.2,0-2.5,0-4.4.9-6.3,1.1-45.2,2.9-96.3,2.5-140.8-6.3-.9-.2-2-.8-3.2-1.1-.8-3.5,1.2-3.4,4.2-4.2,15.8-4.4,38.6-3.5,55.2-4.2,45.4-1.7,93.9-1.6,139.2,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M566.7,1170.2v3.2c-40.6,1.8-86.1,2.5-126.3-3.5-3.7-.5-8.7-1.5-12.3-2.5s-2.6-.2-2.3-3.5c44.6,8.8,95.6,9.2,140.8,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M645.5,1159.7c-.4-1.6-.4-2.3,1.5-2s5,.6,7.4,1,1.8-.6,1.6,2.1c-1.4,0-3.2-.3-4.5.3-23.4,9.4-53.2,11-78.6,12.4v-4.2c1.4,0,2.8,0,4.2,0s4.8,3.4,4.2-1.1c1.4,0,2.8,0,4.2,0-.6,3.2,1.6,2,3.6,2.1,9.5.4,13.6-1.9,21.6-3.2s6.7-.6,9.5-1.1c8.7-1.5,17.5-3.3,26.3-4.2.4-.2-.9-1.5-1.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M627.7,1157.6c4.3.5,8.9,2,13.7,2.1s2.8,0,4.2,0c.1.6,1.4,1.8,1.1,2.1-8.8.9-17.6,2.7-26.3,4.2-1.3-2.8,2.1-3.3,2.1-3.8.2-1.6-1.3-3.8-1.1-5.6,2.4.2,4.3.8,6.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M422.7,1162.8c-6.1-1.4-5.3-.8-9.8-3.9-1.1-.7-3.2.6-2.8-1.3,4.5.3,8.6-1,13.1-1.1s4.3-.9,3.7,2.1c-3,.8-5,.7-4.2,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M627.7,1157.6c1.1-2,13.1-.4,13.7,0s0,1.5,0,2.1c-4.7-.1-9.4-1.6-13.7-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M573,1169.1v4.2c-2.1.1-4.2,0-6.3,0v-3.2c1.9-.1,3.8-1,6.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M423.8,1172.3l-3.2-1.1c2.1.2,3,1,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M414.3,587.9l-3.2-1.1c1.7.4,1.8.5,3.2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M594,540.6l-.5,1-1.6-1c.7,0,1.4,0,2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M423.8,539.5c.1-.5.6-1,1.1-1.1l-1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M540.4,547.9c.2,1.6-2.8,1.5-4,1.8-39.3,8.4-106,4.1-144.4-8.4-1.1-.4-3.2-.3-2.9-1.8l151.3,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M585.6,1168.1c7.1-1.1,15.6-3.9,22.7-4.2s1.5,1.7,2.5,3.1c-8,1.3-12.1,3.6-21.6,3.2s-4.2,1.1-3.6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M581.4,1168.1c.6,4.5-3.2,1.1-4.2,1.1,1.2-1.4,2.7-.9,4.2-1.1Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.3ee85958451a43d9d3c2718f3d8d9c3c.svg";
export { ForwardRef as ReactComponent };